import {c as cookieKeys,a as configRef,l as localStorageKeys,D as DEFAULT_DEADLINE}from'./config.js';import {jsx,jsxs}from'react/jsx-runtime';import {createContext,useContext,useSyncExternalStore,useState,useEffect,useRef,useMemo,useCallback,useReducer}from'react';import {chainsData,liveHostAddress,calcPrematchOdds,calcLiveOdds,PrematchConditionsBatchDocument,getFreeBets,ODDS_DECIMALS,ConditionStatus,MIN_LIVE_BET_AMOUNT,MainGameInfoFragmentDoc,PrematchConditionFragmentDoc,liveSupportedChains,Bet_OrderBy,OrderDirection,GraphBetStatus,PrematchBetsDocument,BetResult,SelectionResult,PrematchGraphGameStatus,LiveBetsDocument,GamesDocument,PrematchConditionsDocument,LiveConditionsDocument,MARGIN_DECIMALS,GameDocument,GameStatus,groupConditionsByMarket,Game_OrderBy,SportsDocument,SportsNavigationDocument,NavigationDocument,getLiveBetFee,BettorsDocument,GameBetsDocument,LiveBetFragmentDoc,PrematchBetFragmentDoc,BettorFragmentDoc,LiveConditionFragmentDoc,LiveConditionDocument,PrematchConditionDocument,liveCoreAbi,freeBetAbi,calcMindOdds,getLiveBetTypedData,createLiveBet,LiveBetState,getLiveBet,getPrematchBetDataBytes,getGameStatus,getWaveLevels,getWaveStats,getWavePeriods,getWaveLeaderBoard,activateWave,getDeBridgeSupportedChains,getDeBridgeSupportedTokens,createDeBridgeBet,getDeBridgeOrder,DeBridgeExternalCallStatus,DeBridgeOrderStatus}from'@azuro-org/toolkit';import {useAccount,useConfig,useWatchContractEvent,usePublicClient,useSendTransaction,useWaitForTransactionReceipt,useReadContract,useBalance,useWalletClient,useWriteContract}from'wagmi';import {HttpLink,ApolloClient,InMemoryCache,useQuery as useQuery$1}from'@apollo/client';import {getMarketName,getSelectionName}from'@azuro-org/dictionaries';import {decodeEventLog,formatUnits,parseUnits,encodeFunctionData,erc20Abi,maxUint256,zeroAddress}from'viem';import {useQuery,useQueryClient,useMutation}from'@tanstack/react-query';import {readContract,getTransactionReceipt}from'@wagmi/core';var SportHub;
(function (SportHub) {
    SportHub["Sports"] = "sports";
    SportHub["Esports"] = "esports";
    SportHub["Unique"] = "unique";
})(SportHub || (SportHub = {}));
var BetType;
(function (BetType) {
    BetType["Unredeemed"] = "unredeemed";
    BetType["Accepted"] = "accepted";
    BetType["Settled"] = "settled";
})(BetType || (BetType = {}));const DumbContext = createContext(undefined);
let ready = false;
let listeners = [];
const readyStore = {
    setReady(value = true) {
        ready = value;
        emitChange();
    },
    subscribe(listener) {
        listeners = [...listeners, listener];
        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    },
    getSnapshot() {
        return ready;
    },
};
const emitChange = () => {
    for (let listener of listeners) {
        listener();
    }
};
let useAccountWithAA = () => useContext(DumbContext);
let _useAAWalletClient = () => useContext(DumbContext);
const useExtendedAccount = () => {
    const account = useAccount();
    const ready = useSyncExternalStore(readyStore.subscribe, readyStore.getSnapshot, () => false);
    const accountWithAA = useAccountWithAA();
    return accountWithAA || { ...account, isAAWallet: false, ready };
};
const useAAWalletClient = () => {
    useSyncExternalStore(readyStore.subscribe, readyStore.getSnapshot, () => false);
    return _useAAWalletClient();
};
(async () => {
    try {
        const pkg = await import('@azuro-org/sdk-social-aa-connector');
        if (typeof pkg.useAccount === 'function') {
            useAccountWithAA = pkg.useAccount;
        }
        if (typeof pkg.useAAWalletClient === 'function') {
            _useAAWalletClient = pkg.useAAWalletClient;
        }
        readyStore.setReady();
    }
    catch (e) {
        readyStore.setReady();
    }
})();const ChainContext = createContext(null);
const useChain = () => {
    return useContext(ChainContext);
};
const ChainProvider = (props) => {
    const { children, initialChainId } = props;
    const [appChainId, setAppChainId] = useState(initialChainId);
    const { chain: walletChain, isAAWallet } = useExtendedAccount();
    const aaWalletClient = useAAWalletClient();
    const walletChainId = walletChain?.id || null;
    const isRightNetwork = walletChainId === appChainId;
    const { chain, contracts, betToken, graphql, socket, api, environment } = chainsData[appChainId];
    const handleChangeChain = (chainId) => {
        document.cookie = `${cookieKeys.appChainId}=${chainId};path=/;`;
        setAppChainId(chainId);
    };
    useEffect(() => {
        if (isAAWallet && aaWalletClient && aaWalletClient.chain.id !== appChainId) {
            aaWalletClient.switchChain({ id: appChainId });
        }
    }, [isAAWallet, aaWalletClient, appChainId]);
    const context = {
        appChain: chain,
        walletChain,
        contracts,
        betToken,
        graphql,
        socket,
        api,
        environment,
        isRightNetwork,
        setAppChainId: handleChangeChain,
    };
    return (jsx(ChainContext.Provider, { value: context, children: children }));
};const getPrematchLink = (chainId) => {
    return new HttpLink({
        uri: ({ operationName }) => `${chainsData[chainId].graphql.prematch}?op=${operationName}`,
    });
};
const getLiveLink = (chainId) => {
    return new HttpLink({
        uri: ({ operationName }) => `${chainsData[chainId].graphql.live}?op=${operationName}`,
    });
};
const typePolicies = {
    Query: {
        fields: {
            bets: {
                merge(existing, incoming, { args }) {
                    // in case of fetching first paginated portion, we should drop cache to avoid data mismatch/shifting
                    if (!args?.skip || !existing?.length) {
                        return incoming;
                    }
                    return [...(existing || []), ...incoming];
                },
            },
            liveBets: {
                merge(existing, incoming, { args }) {
                    // in case of fetching first paginated portion, we should drop cache to avoid data mismatch/shifting
                    if (!args?.skip || !existing?.length) {
                        return incoming;
                    }
                    return [...(existing || []), ...incoming];
                },
            },
        },
    },
};
const getPrematchApolloClient = (chainId) => {
    const link = getPrematchLink(chainId);
    return new ApolloClient({
        link,
        ssrMode: typeof window === 'undefined',
        cache: new InMemoryCache({ typePolicies }),
        connectToDevTools: true,
        assumeImmutableResults: true,
    });
};
const getLiveApolloClient = (chainId) => {
    const link = getLiveLink(chainId);
    return new ApolloClient({
        link,
        ssrMode: typeof window === 'undefined',
        cache: new InMemoryCache(),
        connectToDevTools: true,
        assumeImmutableResults: true,
    });
};
const apolloClients = {
    prematchClient: null,
    liveClient: null,
};
const getApolloClients = (chainId) => {
    if (typeof window === 'undefined') {
        return {
            prematchClient: getPrematchApolloClient(chainId),
            liveClient: getLiveApolloClient(chainId),
        };
    }
    if (!apolloClients.prematchClient) {
        apolloClients.prematchClient = getPrematchApolloClient(chainId);
        apolloClients.liveClient = getLiveApolloClient(chainId);
    }
    return apolloClients;
};
const Context = createContext(null);
const useApolloClients = () => {
    return useContext(Context);
};
const ApolloProvider = (props) => {
    const { children } = props;
    const { appChain } = useChain();
    const prevAppChainIdRef = useRef(appChain.id);
    const apolloClientsRef = useRef(getApolloClients(appChain.id));
    // set new link before render for send requests with new one
    useMemo(() => {
        if (appChain.id !== prevAppChainIdRef.current) {
            const { prematchClient, liveClient } = apolloClientsRef.current;
            const prematchLink = getPrematchLink(appChain.id);
            prematchClient.setLink(prematchLink);
            prematchClient.resetStore();
            if (chainsData[prevAppChainIdRef.current].graphql.live !== chainsData[appChain.id].graphql.live) {
                const liveLink = getLiveLink(appChain.id);
                liveClient.setLink(liveLink);
                liveClient.resetStore();
            }
            prevAppChainIdRef.current = appChain.id;
        }
    }, [appChain.id]);
    return (jsx(Context.Provider, { value: apolloClientsRef.current, children: children }));
};function debounce(func, wait, withMaxRequests) {
    let timeout;
    let requests = 0;
    return function (...args) {
        const context = this;
        const later = function () {
            timeout = undefined;
            requests = 0;
            func.apply(context, args);
        };
        if (withMaxRequests) {
            requests++;
        }
        if (timeout !== undefined) {
            clearTimeout(timeout);
        }
        if (requests > 10) {
            requests = 0;
            func.apply(context, args);
        }
        else {
            timeout = setTimeout(later, wait);
        }
    };
}const createQueueAction = (subscribe, unsubscribe) => {
    const actions = {
        subscribe: [],
        unsubscribe: [],
    };
    // group batch requests
    const request = debounce(() => {
        const subscribeQueue = [...actions.subscribe];
        const unsubscribeQueue = [...actions.unsubscribe];
        actions.subscribe = [];
        actions.unsubscribe = [];
        const weights = {};
        subscribeQueue.forEach(id => {
            if (!weights[id]) {
                weights[id] = 1;
            }
            else {
                weights[id]++;
            }
        });
        unsubscribeQueue.forEach(id => {
            if (!weights[id]) {
                weights[id] = -1;
            }
            else {
                weights[id]--;
            }
        });
        const { subscribeWeights, unsubscribeWeights } = Object.keys(weights).reduce((acc, id) => {
            // ATTN: equal cause we need to fire subscribe for new elements
            // and then trigger watcher (we don't have store)
            if (weights[id] >= 0) {
                acc.subscribeWeights[id] = weights[id];
            }
            else if (weights[id] < 0) {
                acc.unsubscribeWeights[id] = weights[id];
            }
            return acc;
        }, {
            subscribeWeights: {},
            unsubscribeWeights: {},
        });
        if (Object.keys(subscribeWeights).length) {
            subscribe(subscribeWeights);
        }
        if (Object.keys(unsubscribeWeights).length) {
            unsubscribe(unsubscribeWeights);
        }
    }, 50);
    const run = (action, values) => {
        request();
        values.forEach(value => {
            actions[action].push(value);
        });
    };
    return run;
};const timers$1 = new Map();
const subscribers$1 = new Map();
const subscribe$1 = (conditionId, cb) => {
    const key = conditionId;
    const handlers = subscribers$1.get(key) || [];
    handlers.push({ cb });
    subscribers$1.set(key, handlers);
    return function unsubscribe() {
        const handlers = subscribers$1.get(key) || [];
        const newHandlers = handlers.filter((handler) => handler.cb !== cb);
        if (newHandlers.length) {
            subscribers$1.set(key, newHandlers);
        }
        else {
            subscribers$1.delete(key);
        }
    };
};
const trigger$1 = (conditionId, status) => {
    const handlers = subscribers$1.get(conditionId) || [];
    handlers.forEach(({ cb }) => {
        cb(status);
    });
};
const dispatch$1 = (conditionId, status) => {
    let timer = timers$1.get(conditionId);
    if (timer !== undefined) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        timers$1.delete(conditionId);
        trigger$1(conditionId, status);
    }, 200);
    timers$1.set(conditionId, timer);
};
const conditionStatusWatcher = {
    subscribe: subscribe$1,
    dispatch: dispatch$1,
};const timers = new Map();
const subscribers = new Map();
const subscribe = (conditionId, outcomeId, cb) => {
    const key = conditionId;
    const handlers = subscribers.get(key) || [];
    handlers.push({ outcomeId, cb });
    subscribers.set(key, handlers);
    return function unsubscribe() {
        const handlers = subscribers.get(key) || [];
        const newHandlers = handlers.filter((handler) => handler.cb !== cb);
        if (newHandlers.length) {
            subscribers.set(key, newHandlers);
        }
        else {
            subscribers.delete(key);
        }
    };
};
const trigger = async (conditionId, oddsData) => {
    const handlers = subscribers.get(conditionId) || [];
    handlers.forEach(({ cb }) => {
        cb(oddsData);
    });
};
const dispatch = (conditionId, oddsData) => {
    let timer = timers.get(conditionId);
    if (timer !== undefined) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        timers.delete(conditionId);
        trigger(conditionId, oddsData);
    }, 200);
    timers.set(conditionId, timer);
};
const oddsWatcher = {
    subscribe,
    dispatch,
};var SocketCloseReason;
(function (SocketCloseReason) {
    SocketCloseReason[SocketCloseReason["ChainChanged"] = 3000] = "ChainChanged";
})(SocketCloseReason || (SocketCloseReason = {}));
const SocketContext = createContext(null);
const useSocket = () => {
    return useContext(SocketContext);
};
const SocketProvider = ({ children }) => {
    const { appChain } = useChain();
    const [isSocketReady, setSocketReady] = useState(false);
    const prevChainId = useRef(appChain.id);
    const socket = useRef();
    const subscribers = useRef({});
    const subscribe = useCallback((weights) => {
        if (socket.current?.readyState !== 1) {
            return;
        }
        Object.keys(weights).forEach((conditionId) => {
            if (typeof subscribers.current[conditionId] === 'undefined') {
                subscribers.current[conditionId] = 0;
            }
            subscribers.current[conditionId] += weights[conditionId];
        });
        socket.current.send(JSON.stringify({
            action: 'subscribe',
            conditionIds: Object.keys(weights),
        }));
    }, []);
    const unsubscribeCall = (conditionIds) => {
        if (socket.current?.readyState !== 1) {
            return;
        }
        socket.current.send(JSON.stringify({
            action: 'unsubscribe',
            conditionIds,
        }));
    };
    const unsubscribe = useCallback((weights) => {
        if (socket.current?.readyState !== 1) {
            return;
        }
        // we mustn't unsubscribe for condition if it has more that 1 subscriber
        const newUnsubscribers = [];
        Object.keys(weights).forEach((conditionId) => {
            if (subscribers.current[conditionId]) {
                subscribers.current[conditionId] += weights[conditionId];
                if (subscribers.current[conditionId] === 0) {
                    delete subscribers.current[conditionId];
                    newUnsubscribers.push(conditionId);
                }
            }
        });
        if (!newUnsubscribers.length) {
            return;
        }
        unsubscribeCall(newUnsubscribers);
    }, []);
    const runAction = useCallback(createQueueAction(subscribe, unsubscribe), []);
    const subscribeToUpdates = useCallback((conditionIds) => {
        runAction('subscribe', conditionIds);
    }, []);
    const unsubscribeToUpdates = useCallback((conditionIds) => {
        runAction('unsubscribe', conditionIds);
    }, []);
    const connect = () => {
        socket.current = new WebSocket(chainsData[appChain.id].socket);
        socket.current.onopen = () => {
            setSocketReady(true);
        };
        socket.current.onclose = (event) => {
            subscribers.current = {};
            socket.current = undefined;
            setSocketReady(false);
            if (event.code === SocketCloseReason.ChainChanged) {
                return;
            }
            connect();
        };
        socket.current.onmessage = (message) => {
            JSON.parse(message.data.toString()).forEach((data) => {
                const { id: conditionId, reinforcement, margin, winningOutcomesCount } = data;
                if (data.outcomes) {
                    const eventData = {
                        conditionId: conditionId,
                        reinforcement: +reinforcement,
                        margin: +margin,
                        winningOutcomesCount: +winningOutcomesCount,
                        outcomes: {},
                    };
                    eventData.outcomes = data.outcomes.reduce((acc, { id, odds, clearOdds, maxStake }) => {
                        acc[id] = {
                            odds,
                            clearOdds,
                            maxBet: maxStake,
                        };
                        return acc;
                    }, {});
                    oddsWatcher.dispatch(conditionId, eventData);
                }
                if (data.state) {
                    conditionStatusWatcher.dispatch(conditionId, data.state);
                }
            });
        };
        socket.current.onerror = () => {
            subscribers.current = {};
            socket.current = undefined;
            setSocketReady(false);
            setTimeout(connect, 1000);
        };
    };
    useEffect(() => {
        if (isSocketReady
            && socket.current
            && prevChainId.current !== appChain.id
            && chainsData[prevChainId.current].socket !== chainsData[appChain.id].socket) {
            unsubscribeCall(Object.keys(subscribers.current));
            socket.current.close(SocketCloseReason.ChainChanged);
        }
        prevChainId.current = appChain.id;
    }, [chainsData[appChain.id].socket, isSocketReady]);
    useEffect(() => {
        if (typeof socket.current !== 'undefined' || isSocketReady) {
            return;
        }
        connect();
    }, [chainsData[appChain.id].socket, isSocketReady]);
    const value = {
        isSocketReady,
        subscribeToUpdates,
        unsubscribeToUpdates,
    };
    return (jsx(SocketContext.Provider, { value: value, children: children }));
};let ref = {
    lastUpdateTime: undefined,
};
const getGameStartsAtValue = () => {
    let startsAt;
    const dateNow = Math.floor(Date.now() / 1000);
    // if first render or current time is greater the previous saved more than cache time
    if (!ref.lastUpdateTime
        || dateNow - ref.lastUpdateTime > configRef.gamesCacheTime) {
        startsAt = dateNow;
        ref.lastUpdateTime = dateNow;
    }
    else {
        startsAt = ref.lastUpdateTime;
    }
    return startsAt;
};const getEventArgsFromTxReceipt = ({ receipt, eventName, abi, params }) => {
    const { logs } = receipt;
    let result;
    for (let index = 0; index < logs.length; index++) {
        try {
            const log = logs[index];
            result = decodeEventLog({
                abi,
                topics: log.topics,
                eventName,
                data: log.data,
            });
            if (result.eventName.toLowerCase() !== eventName.toLowerCase()) {
                result = undefined;
                continue;
            }
            if (params && result?.args) {
                const isMatchByParams = Object.keys(params).every(paramKey => {
                    return result.args[paramKey] === params[paramKey];
                });
                if (!isMatchByParams) {
                    result = undefined;
                }
            }
            if (result) {
                break;
            }
        }
        catch { }
    }
    if (result?.args) {
        return result?.args;
    }
};const formatToFixed = (value, digitsCount) => {
    value = String(value);
    if (!/\./.test(value)) {
        return +value;
    }
    const [int, digits] = value.split('.');
    return +`${int}.${digits.substr(0, digitsCount)}`;
};const createBatch = (fn, isSet = true) => {
    let idsWaitList = isSet ? new Set() : [];
    let resolversWaitList = [];
    const request = debounce(async (fn, ...rest) => {
        const ids = [...idsWaitList];
        const resolvers = resolversWaitList;
        if (idsWaitList instanceof Set) {
            idsWaitList.clear();
        }
        else {
            idsWaitList = [];
        }
        resolversWaitList = [];
        try {
            const data = await fn(ids, ...rest);
            resolvers.forEach((resolve) => {
                resolve(data);
            });
        }
        catch (err) {
            resolvers.forEach((resolve) => {
                resolve(undefined);
            });
        }
    }, 50, true);
    const batch = (ids, ...rest) => {
        request(fn, ...rest);
        ids.forEach(id => {
            if (idsWaitList instanceof Set) {
                idsWaitList.add(id);
            }
            else {
                idsWaitList.push(id);
            }
        });
        return new Promise((resolve) => {
            resolversWaitList.push(resolve);
        });
    };
    return batch;
};const useIsMounted = () => {
    const isMountedRef = useRef(false);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    return () => isMountedRef.current;
};const useOdds = ({ selections, betAmount, batchBetAmounts }) => {
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const { appChain } = useChain();
    const config = useConfig();
    const isMounted = useIsMounted();
    const { liveItems, prematchItems } = useMemo(() => {
        return selections.reduce((acc, item) => {
            if (item.coreAddress.toLocaleLowerCase() === liveHostAddress.toLocaleLowerCase()) {
                acc.liveItems.push(item);
            }
            else {
                acc.prematchItems.push(item);
            }
            return acc;
        }, {
            liveItems: [],
            prematchItems: [],
        });
    }, [selections]);
    const selectionsKey = useMemo(() => (selections.map(({ conditionId }) => conditionId).join('-')), [selections]);
    const liveKey = useMemo(() => (liveItems.map(({ conditionId }) => conditionId).join('-')), [liveItems]);
    const prematchKey = useMemo(() => (prematchItems.map(({ conditionId }) => conditionId).join('-')), [prematchItems]);
    const [odds, setOdds] = useState({});
    const [totalOdds, setTotalOdds] = useState(0);
    const [isPrematchOddsFetching, setPrematchOddsFetching] = useState(Boolean(prematchItems.length));
    const oddsDataRef = useRef({});
    const betAmountRef = useRef(betAmount);
    const batchBetAmountsRef = useRef(batchBetAmounts);
    const prevSelectionsKeyRef = useRef(selectionsKey);
    const prevPrematchKeyRef = useRef(prematchKey);
    if (prematchItems.length && (prematchKey !== prevPrematchKeyRef.current
        || betAmount !== betAmountRef.current
        || batchBetAmounts !== batchBetAmountsRef.current)) {
        setPrematchOddsFetching(true);
    }
    if (selectionsKey !== prevSelectionsKeyRef.current
        || betAmount !== betAmountRef.current
        || batchBetAmounts !== batchBetAmountsRef.current) {
        setOdds({});
        setTotalOdds(1);
    }
    prevSelectionsKeyRef.current = selectionsKey;
    prevPrematchKeyRef.current = prematchKey;
    betAmountRef.current = betAmount;
    batchBetAmountsRef.current = batchBetAmounts;
    const isLiveOddsFetching = useMemo(() => {
        return !liveItems.every(({ conditionId, outcomeId }) => Boolean(odds[`${conditionId}-${outcomeId}`]));
    }, [liveKey, odds]);
    const maxBet = useMemo(() => {
        if (!liveItems.length || liveItems.length > 1) {
            return undefined;
        }
        const { conditionId, outcomeId } = liveItems[0];
        return oddsDataRef.current?.[conditionId]?.outcomes?.[outcomeId]?.maxBet;
    }, [liveKey, odds]); // we need odds in deps because we update oddsDataRef with odds
    const fetchPrematchOdds = async () => {
        if (!prematchItems.length) {
            return;
        }
        try {
            const prematchOdds = await calcPrematchOdds({
                config,
                betAmount: betAmountRef.current,
                batchBetAmounts: batchBetAmountsRef.current,
                selections: prematchItems,
                chainId: appChain.id,
            });
            if (isMounted()) {
                setOdds(odds => {
                    const newOdds = { ...odds, ...prematchOdds };
                    const newTotalOdds = formatToFixed(Object.keys(newOdds).reduce((acc, key) => acc * +newOdds[key], 1), 5);
                    setTotalOdds(newTotalOdds);
                    return newOdds;
                });
                setPrematchOddsFetching(false);
            }
        }
        catch (err) {
            if (isMounted()) {
                setPrematchOddsFetching(false);
            }
        }
    };
    const fetchLiveOdds = (items, newOddsData) => {
        if (!items.length) {
            return;
        }
        if (newOddsData) {
            oddsDataRef.current[newOddsData.conditionId] = newOddsData;
        }
        const liveOdds = items.reduce((acc, item) => {
            const { conditionId, outcomeId } = item;
            const oddsData = oddsDataRef.current[conditionId];
            if (!oddsData) {
                return acc;
            }
            acc[`${conditionId}-${outcomeId}`] = calcLiveOdds({ selection: item, betAmount: betAmountRef.current, oddsData });
            return acc;
        }, {});
        setOdds(odds => {
            const newOdds = { ...odds, ...liveOdds };
            const newTotalOdds = formatToFixed(Object.keys(newOdds).reduce((acc, key) => acc * +newOdds[key], 1), 3);
            setTotalOdds(newTotalOdds);
            return newOdds;
        });
    };
    const fetchOdds = useCallback(debounce(() => {
        fetchPrematchOdds();
        fetchLiveOdds(liveItems);
    }, 100), [selectionsKey]);
    useEffect(() => {
        if (!isSocketReady || !liveItems.length) {
            return;
        }
        const ids = liveKey.split('-');
        subscribeToUpdates(ids);
        return () => {
            unsubscribeToUpdates(ids);
        };
    }, [liveKey, isSocketReady]);
    useEffect(() => {
        fetchOdds();
    }, [fetchOdds, betAmount, batchBetAmounts]);
    useEffect(() => {
        if (!selections?.length) {
            return;
        }
        const unsubscribeList = selections.map(({ conditionId, outcomeId }) => {
            return oddsWatcher.subscribe(`${conditionId}`, `${outcomeId}`, (oddsData) => {
                if (oddsData) {
                    const item = liveItems.find(item => item.conditionId === oddsData.conditionId);
                    fetchLiveOdds([item], oddsData);
                }
                else {
                    setPrematchOddsFetching(true);
                    fetchPrematchOdds();
                }
            });
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [selectionsKey]);
    return {
        odds,
        totalOdds,
        maxBet,
        loading: isPrematchOddsFetching || isLiveOddsFetching,
    };
};const getOutcomes = async (conditionEntityIds, client) => {
    const result = await client.query({
        query: PrematchConditionsBatchDocument,
        variables: {
            conditionFilter: {
                id_in: conditionEntityIds,
            },
        },
        fetchPolicy: 'network-only',
    });
    return result?.data?.conditions.reduce((acc, { conditionId, outcomes, status }) => {
        outcomes.forEach(({ outcomeId, odds }) => {
            const key = `${conditionId}-${outcomeId}`;
            acc[key] = {
                odds: +odds,
                status,
            };
        });
        return acc;
    }, {});
};
const batchFetchOutcomes = createBatch(getOutcomes);const useStatuses = ({ selections }) => {
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const { prematchClient } = useApolloClients();
    const [statuses, setStatuses] = useState({});
    const { liveItems, prematchItems } = useMemo(() => {
        return selections.reduce((acc, item) => {
            if (item.coreAddress.toLocaleLowerCase() === liveHostAddress.toLocaleLowerCase()) {
                acc.liveItems.push(item);
            }
            else {
                acc.prematchItems.push(item);
            }
            return acc;
        }, {
            liveItems: [],
            prematchItems: [],
        });
    }, [selections]);
    const [isPrematchStatusesFetching, setPrematchStatusesFetching] = useState(Boolean(prematchItems.length));
    const selectionsKey = useMemo(() => (selections.map(({ conditionId }) => conditionId).join('-')), [selections]);
    const liveKey = useMemo(() => (liveItems.map(({ conditionId }) => conditionId).join('-')), [liveItems]);
    const prematchKey = useMemo(() => (prematchItems.map(({ conditionId }) => conditionId).join('-')), [prematchItems]);
    const prevSelectionsKeyRef = useRef(selectionsKey);
    const prevPrematchKey = useRef(prematchKey);
    if (prematchItems.length && prematchKey !== prevPrematchKey.current) {
        setPrematchStatusesFetching(true);
    }
    if (selectionsKey !== prevSelectionsKeyRef.current) {
        setStatuses({});
    }
    prevSelectionsKeyRef.current = selectionsKey;
    prevPrematchKey.current = prematchKey;
    const isLiveStatusesFetching = useMemo(() => {
        return !liveItems.every(({ conditionId }) => Boolean(statuses[conditionId]));
    }, [liveKey, statuses]);
    useEffect(() => {
        if (!isSocketReady || !liveItems.length) {
            return;
        }
        const ids = liveKey.split('-');
        subscribeToUpdates(ids);
        return () => {
            unsubscribeToUpdates(ids);
        };
    }, [liveKey, isSocketReady]);
    useEffect(() => {
        if (!selections.length) {
            return;
        }
        const unsubscribeList = selections.map(({ conditionId }) => {
            return conditionStatusWatcher.subscribe(conditionId, (newStatus) => {
                setStatuses(statuses => ({
                    ...statuses,
                    [conditionId]: newStatus,
                }));
            });
        });
        return () => {
            unsubscribeList.forEach((unsubscribe) => {
                unsubscribe();
            });
        };
    }, [selectionsKey]);
    useEffect(() => {
        if (!prematchItems.length) {
            return;
        }
        (async () => {
            const data = await batchFetchOutcomes(prematchItems.map(({ conditionId, coreAddress }) => `${coreAddress.toLowerCase()}_${conditionId}`), prematchClient);
            const prematchStatuses = selections.reduce((acc, { conditionId, outcomeId }) => {
                const key = `${conditionId}-${outcomeId}`;
                const { status } = data?.[key];
                acc[conditionId] = status;
                return acc;
            }, {});
            setPrematchStatusesFetching(false);
            setStatuses(prematchStatuses);
        })();
    }, [prematchKey]);
    return {
        statuses,
        loading: isPrematchStatusesFetching || isLiveStatusesFetching,
    };
};const useFreeBets = ({ account, affiliate, enabled }) => {
    const { appChain, api } = useChain();
    const queryFn = async () => {
        const freebets = await getFreeBets({
            chainId: appChain.id,
            account,
            affiliate,
        });
        if (!freebets) {
            return freebets;
        }
        return freebets.map(freebet => ({
            id: +freebet.id,
            contractAddress: freebet.contract.freebetContractAddress,
            signature: freebet.signature,
            expiresAt: freebet.expiresAt * 1000,
            amount: formatUnits(BigInt(freebet.amount), freebet.contract.decimals),
            rawAmount: BigInt(freebet.amount),
            minOdds: formatUnits(BigInt(freebet.minOdds), ODDS_DECIMALS),
            rawMinOdds: BigInt(freebet.minOdds),
            campaign: freebet.campaign,
            chainId: +freebet.contract.chainId,
        }));
    };
    const { data, ...rest } = useQuery({
        queryKey: ['freebets', api, account?.toLowerCase(), affiliate?.toLowerCase()],
        queryFn,
        refetchOnWindowFocus: false,
        enabled,
    });
    const appChainFreeBets = useMemo(() => {
        if (!data) {
            return data;
        }
        return data.filter(({ chainId }) => +chainId === appChain.id);
    }, [data, appChain.id]);
    return {
        data: appChainFreeBets,
        ...rest,
    };
};const formatBetValue = (value) => {
    let newValue = value;
    const [int, digits] = newValue.split('.');
    if (digits) {
        newValue = `${int}.${digits.substring(0, 2)}`;
    }
    return newValue;
};const useForceUpdate = () => {
    const [increment, setState] = useState(0);
    const forceUpdate = useCallback(() => {
        setState((v) => ++v);
    }, []);
    return { increment, forceUpdate };
};var BetslipDisableReason;
(function (BetslipDisableReason) {
    BetslipDisableReason["ConditionStatus"] = "ConditionStatus";
    BetslipDisableReason["BetAmountGreaterThanMaxBet"] = "BetAmountGreaterThanMaxBet";
    BetslipDisableReason["BetAmountLowerThanMinBet"] = "BetAmountLowerThanMinBet";
    BetslipDisableReason["BatchWithLive"] = "BatchWithLive";
    BetslipDisableReason["ComboWithLive"] = "ComboWithLive";
    BetslipDisableReason["ComboWithForbiddenItem"] = "ComboWithForbiddenItem";
    BetslipDisableReason["ComboWithSameGame"] = "ComboWithSameGame";
    BetslipDisableReason["PrematchConditionInStartedGame"] = "PrematchConditionInStartedGame";
    BetslipDisableReason["FreeBetWithLive"] = "FreeBetWithLive";
    BetslipDisableReason["FreeBetWithCombo"] = "FreeBetWithCombo";
    BetslipDisableReason["FreeBetWithBatch"] = "FreeBetWithBatch";
    BetslipDisableReason["FreeBetExpired"] = "FreeBetExpired";
    BetslipDisableReason["FreeBetMinOdds"] = "FreeBetMinOdds";
})(BetslipDisableReason || (BetslipDisableReason = {}));
const BaseBetslipContext = createContext(null);
const DetailedBetslipContext = createContext(null);
const useBaseBetslip = () => {
    return useContext(BaseBetslipContext);
};
const useDetailedBetslip = () => {
    return useContext(DetailedBetslipContext);
};
const BetslipProvider = (props) => {
    const { children, affiliate, isBatchBetWithSameGameEnabled } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const { appChain } = useChain();
    const account = useExtendedAccount();
    const { forceUpdate } = useForceUpdate();
    const [items, setItems] = useState([]);
    const [selectedFreeBet, setFreeBet] = useState();
    const [betAmount, setBetAmount] = useState('');
    const [batchBetAmounts, setBatchBetAmounts] = useState({});
    const [isBatch, setBatch] = useState(false);
    const { data: freeBets, isFetching: isFreeBetsFetching } = useFreeBets({
        account: account.address,
        affiliate: affiliate,
        enabled: Boolean(affiliate),
    });
    const { odds, totalOdds, maxBet, loading: isOddsFetching } = useOdds({ betAmount, batchBetAmounts, selections: items });
    const { statuses, loading: isStatusesFetching } = useStatuses({ selections: items });
    const isCombo = !isBatch && items.length > 1;
    const checkDifferentGames = (items) => {
        const gameIds = items.map(({ game }) => game.gameId);
        return gameIds.length === new Set(gameIds).size;
    };
    const createInitialBatchAmounts = (items) => {
        setBatchBetAmounts(batchAmounts => {
            const newBatchAmounts = {};
            items.forEach(({ conditionId, outcomeId }) => {
                const key = `${conditionId}-${outcomeId}`;
                newBatchAmounts[key] = batchAmounts[key] || '';
            });
            return newBatchAmounts;
        });
    };
    const totalBetAmount = useMemo(() => {
        if (isBatch) {
            return String(Object.values(batchBetAmounts).reduce((acc, amount) => acc + +amount, 0));
        }
        if (selectedFreeBet) {
            return selectedFreeBet.amount;
        }
        return betAmount;
    }, [isBatch, betAmount, batchBetAmounts, selectedFreeBet]);
    const isLiveBet = useMemo(() => {
        return items.some(({ coreAddress }) => coreAddress === liveHostAddress);
    }, [items]);
    const isConditionsInCreatedStatus = useMemo(() => {
        return Object.values(statuses).every(status => status === ConditionStatus.Created);
    }, [statuses]);
    const isComboWithDifferentGames = useMemo(() => {
        return !isCombo || checkDifferentGames(items);
    }, [isCombo, items]);
    const isBatchAllowed = !isBatch || !isLiveBet;
    const isFreeBetAllowed = useMemo(() => {
        if (!selectedFreeBet || !totalOdds) {
            return true;
        }
        return (!isCombo && !isBatch && !isLiveBet
            && selectedFreeBet.expiresAt > Date.now()
            && totalOdds >= parseFloat(selectedFreeBet.minOdds));
    }, [selectedFreeBet, isCombo, isBatch, isLiveBet, totalOdds]);
    const isComboAllowed = useMemo(() => {
        return !isCombo || !isLiveBet && isComboWithDifferentGames && items.every(({ isExpressForbidden }) => !isExpressForbidden);
    }, [isCombo, items]);
    const isPrematchBetAllowed = useMemo(() => {
        return items.every(({ coreAddress, game: { startsAt } }) => {
            if (coreAddress === liveHostAddress) {
                return true;
            }
            return startsAt * 1000 > Date.now();
        });
    }, [items]);
    const minBet = isLiveBet && !appChain?.testnet ? MIN_LIVE_BET_AMOUNT : undefined;
    const isAmountLowerThanMaxBet = Boolean(betAmount) && typeof maxBet !== 'undefined' ? +betAmount <= maxBet : true;
    const isAmountBiggerThanMinBet = Boolean(betAmount) && typeof minBet !== 'undefined' ? +betAmount >= minBet : true;
    const isBetAllowed = (isConditionsInCreatedStatus
        && isComboAllowed
        && isBatchAllowed
        && isPrematchBetAllowed
        && isFreeBetAllowed
        && isAmountLowerThanMaxBet
        && isAmountBiggerThanMinBet);
    let disableReason = (() => {
        if (!isConditionsInCreatedStatus) {
            return BetslipDisableReason.ConditionStatus;
        }
        if (!isFreeBetAllowed) {
            if (isLiveBet) {
                return BetslipDisableReason.FreeBetWithLive;
            }
            else {
                if (isCombo) {
                    return BetslipDisableReason.FreeBetWithCombo;
                }
                if (isBatch) {
                    return BetslipDisableReason.FreeBetWithBatch;
                }
            }
            if (selectedFreeBet.expiresAt <= Date.now()) {
                return BetslipDisableReason.FreeBetExpired;
            }
            if (totalOdds < parseFloat(selectedFreeBet.minOdds)) {
                return BetslipDisableReason.FreeBetMinOdds;
            }
        }
        if (!isComboAllowed) {
            if (isLiveBet) {
                return BetslipDisableReason.ComboWithLive;
            }
            else if (!isComboWithDifferentGames) {
                return BetslipDisableReason.ComboWithSameGame;
            }
            else {
                return BetslipDisableReason.ComboWithForbiddenItem;
            }
        }
        if (!isPrematchBetAllowed) {
            return BetslipDisableReason.PrematchConditionInStartedGame;
        }
        if (!isBatchAllowed) {
            return BetslipDisableReason.BatchWithLive;
        }
        if (!isAmountLowerThanMaxBet) {
            return BetslipDisableReason.BetAmountGreaterThanMaxBet;
        }
        if (!isAmountBiggerThanMinBet) {
            return BetslipDisableReason.BetAmountLowerThanMinBet;
        }
    })();
    const changeBatch = useCallback((value) => {
        setBatch(value);
        if (value) {
            setBetAmount('');
            createInitialBatchAmounts(items);
        }
        else {
            setBatchBetAmounts({});
        }
    }, [items]);
    const changeBetAmount = useCallback((value) => {
        setBetAmount(formatBetValue(value));
    }, []);
    const changeBatchBetAmount = useCallback((item, value) => {
        const { conditionId, outcomeId } = item;
        const key = `${conditionId}-${outcomeId}`;
        setBatchBetAmounts(amounts => {
            return {
                ...amounts,
                [key]: formatBetValue(value),
            };
        });
    }, []);
    const addItem = useCallback((itemProps) => {
        const { gameId, coreAddress, lpAddress, conditionId, outcomeId } = itemProps;
        let game;
        let cache;
        let gameEntityId;
        if (coreAddress === liveHostAddress) {
            cache = liveClient.cache;
            gameEntityId = gameId;
        }
        else {
            cache = prematchClient.cache;
            gameEntityId = `${lpAddress.toLowerCase()}_${gameId}`;
        }
        game = cache.readFragment({
            id: cache.identify({ __typename: 'Game', id: gameEntityId }),
            fragment: MainGameInfoFragmentDoc,
            fragmentName: 'MainGameInfo',
        });
        if (!game) {
            return;
        }
        let marketName = getMarketName({ outcomeId });
        let selectionName = getSelectionName({ outcomeId, withPoint: true });
        if (coreAddress !== liveHostAddress) {
            const conditionEntityId = `${coreAddress.toLowerCase()}_${conditionId}`;
            const condition = cache.readFragment({
                id: cache.identify({ __typename: 'Condition', id: conditionEntityId }),
                fragment: PrematchConditionFragmentDoc,
                fragmentName: 'PrematchCondition',
            });
            if (condition?.title && condition.title !== 'null') {
                marketName = condition.title;
                const outcome = condition.outcomes.find(outcome => outcome.outcomeId === outcomeId);
                if (outcome?.title && outcome.title !== 'null') {
                    selectionName = outcome.title;
                }
            }
        }
        const { participants, startsAt: _startsAt, title, sport: { sportId: _sportId, slug: sportSlug, name: sportName, }, league: { name: leagueName, slug: leagueSlug, country: { name: countryName, slug: countrySlug, }, }, } = game;
        const item = {
            ...itemProps,
            marketName,
            selectionName,
            game: {
                gameId,
                title,
                countryName,
                countrySlug,
                leagueName,
                leagueSlug,
                participants,
                startsAt: +_startsAt,
                sportId: +_sportId,
                sportSlug,
                sportName,
            },
        };
        setItems(items => {
            let newItems;
            const replaceIndex = items.findIndex(({ game: { gameId } }) => gameId === item.game.gameId);
            // if cart contains outcome from same game as new item
            // then replace old item
            if (replaceIndex !== -1) {
                if (isBatchBetWithSameGameEnabled) {
                    const { conditionId, outcomeId } = items[replaceIndex];
                    // if it's exactly the same outcome, don't change the state
                    if (conditionId === item.conditionId && outcomeId === item.outcomeId) {
                        return items;
                    }
                    newItems = [...items, item];
                    setBatch(true);
                    createInitialBatchAmounts(newItems);
                }
                else {
                    newItems = [...items];
                    newItems[replaceIndex] = item;
                }
            }
            else {
                newItems = [...items, item];
            }
            localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify(newItems));
            if (isBatch) {
                createInitialBatchAmounts(newItems);
            }
            return newItems;
        });
    }, [isBatch]);
    const removeItem = useCallback((itemProps) => {
        const { conditionId, outcomeId } = itemProps;
        setItems(items => {
            const newItems = items.filter((item) => !(item.conditionId === conditionId
                && item.outcomeId === outcomeId));
            if (newItems.length < 2) {
                setBatch(false);
            }
            setBatchBetAmounts(batchAmounts => {
                if (newItems.length < 2) {
                    const lastItem = newItems[0];
                    if (lastItem) {
                        const { conditionId, outcomeId } = lastItem;
                        const amount = batchAmounts[`${conditionId}-${outcomeId}`];
                        if (amount) {
                            setBetAmount(amount);
                        }
                    }
                    return {};
                }
                const newBatchAmounts = { ...batchAmounts };
                delete newBatchAmounts[`${conditionId}-${outcomeId}`];
                return newBatchAmounts;
            });
            localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify(newItems));
            return newItems;
        });
    }, []);
    const clear = useCallback(() => {
        setItems([]);
        setBatch(false);
        setBatchBetAmounts({});
        setBetAmount('');
        setFreeBet(undefined);
        localStorage.setItem(localStorageKeys.betslipItems, JSON.stringify([]));
    }, []);
    const prevChainId = useRef(appChain.id);
    useEffect(() => {
        if (prevChainId.current !== appChain.id) {
            clear();
            prevChainId.current = appChain.id;
        }
    }, [appChain.id]);
    useEffect(() => {
        let storedItems = JSON.parse(localStorage.getItem(localStorageKeys.betslipItems) || '[]');
        if (!Array.isArray(storedItems)) {
            return;
        }
        const isDifferentGames = checkDifferentGames(storedItems);
        if (!isDifferentGames) {
            setBatch(true);
            createInitialBatchAmounts(storedItems);
        }
        setItems(storedItems);
    }, []);
    useEffect(() => {
        if (!selectedFreeBet || selectedFreeBet.expiresAt <= Date.now()) {
            return;
        }
        const timeout = setTimeout(() => {
            disableReason = BetslipDisableReason.FreeBetExpired;
            forceUpdate();
        }, selectedFreeBet.expiresAt - Date.now());
        return () => {
            clearTimeout(timeout);
        };
    }, [selectedFreeBet]);
    const baseValue = useMemo(() => ({
        items,
        addItem,
        removeItem,
        clear,
    }), [
        items,
        addItem,
        removeItem,
        clear,
    ]);
    const detailedValue = useMemo(() => ({
        betAmount: totalBetAmount,
        batchBetAmounts,
        odds,
        totalOdds,
        maxBet,
        minBet,
        selectedFreeBet,
        freeBets,
        statuses,
        disableReason,
        changeBetAmount,
        changeBatchBetAmount,
        changeBatch,
        selectFreeBet: setFreeBet,
        isBatch,
        isLiveBet,
        isStatusesFetching,
        isOddsFetching,
        isFreeBetsFetching,
        isBetAllowed,
    }), [
        totalBetAmount,
        batchBetAmounts,
        odds,
        totalOdds,
        maxBet,
        minBet,
        selectedFreeBet,
        freeBets,
        statuses,
        disableReason,
        changeBetAmount,
        changeBatchBetAmount,
        changeBatch,
        setFreeBet,
        isBatch,
        isLiveBet,
        isStatusesFetching,
        isOddsFetching,
        isFreeBetsFetching,
        isBetAllowed,
    ]);
    return (jsx(BaseBetslipContext.Provider, { value: baseValue, children: jsx(DetailedBetslipContext.Provider, { value: detailedValue, children: children }) }));
};const useWatchers = () => {
    const { appChain, contracts } = useChain();
    useWatchContractEvent({
        address: contracts.prematchCore.address,
        abi: contracts.prematchCore.abi,
        eventName: 'NewBet',
        chainId: appChain.id,
        onLogs(logs) {
            if (logs) {
                logs.forEach(log => {
                    const conditionId = log.args.conditionId;
                    oddsWatcher.dispatch(conditionId.toString());
                });
            }
        },
    });
    useWatchContractEvent({
        address: contracts.prematchComboCore.address,
        abi: contracts.prematchComboCore.abi,
        eventName: 'NewBet',
        chainId: appChain.id,
        onLogs(logs) {
            if (logs) {
                logs.forEach(log => {
                    const { subBets } = log.args.bet;
                    subBets.forEach(({ conditionId }) => {
                        oddsWatcher.dispatch(conditionId.toString());
                    });
                });
            }
        },
    });
    useWatchContractEvent({
        address: contracts.prematchCore.address,
        abi: contracts.prematchCore.abi,
        eventName: 'OddsChanged',
        chainId: appChain.id,
        onLogs(logs) {
            if (logs) {
                logs.forEach(log => {
                    const conditionId = log.args.conditionId;
                    oddsWatcher.dispatch(conditionId.toString());
                });
            }
        },
    });
    useWatchContractEvent({
        address: contracts.prematchCore.address,
        abi: contracts.prematchCore.abi,
        eventName: 'ConditionStopped',
        chainId: appChain.id,
        onLogs(logs) {
            if (logs) {
                logs.forEach(log => {
                    const conditionId = log.args.conditionId;
                    const isStopped = log.args.flag;
                    const status = isStopped ? ConditionStatus.Paused : ConditionStatus.Created;
                    conditionStatusWatcher.dispatch(conditionId.toString(), status);
                });
            }
        },
    });
};function Watchers() {
    useWatchers();
    return null;
}
const AzuroSDKProvider = (props) => {
    const { children, initialChainId, affiliate, isBatchBetWithSameGameEnabled } = props;
    return (jsx(ChainProvider, { initialChainId: initialChainId, children: jsxs(SocketProvider, { children: [jsx(ApolloProvider, { children: jsx(BetslipProvider, { isBatchBetWithSameGameEnabled: isBatchBetWithSameGameEnabled, affiliate: affiliate, children: children }) }), jsx(Watchers, {})] }) }));
};const LiveContext = createContext(null);
const useLive = () => {
    return useContext(LiveContext);
};
const LiveProvider = (props) => {
    const { children, initialLiveState } = props;
    const { appChain, setAppChainId } = useChain();
    const [isLive, setLive] = useState(liveSupportedChains.includes(appChain.id) && Boolean(initialLiveState));
    useMemo(() => {
        if (!liveSupportedChains.includes(appChain.id) && isLive) {
            setLive(false);
            document.cookie = `${cookieKeys.live}=false;path=/;`;
        }
    }, [appChain]);
    const handleChangeLive = (value) => {
        document.cookie = `${cookieKeys.live}=${value};path=/;`;
        if (value && !liveSupportedChains.includes(appChain.id)) {
            setAppChainId(liveSupportedChains[0]);
        }
        setLive(value);
    };
    const value = {
        isLive,
        changeLive: handleChangeLive,
    };
    return (jsx(LiveContext.Provider, { value: value, children: children }));
};const usePrematchBets = (props) => {
    const { filter, orderBy = Bet_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Asc, } = props;
    const { prematchClient } = useApolloClients();
    const options = useMemo(() => {
        const variables = {
            first: filter.limit || 1000,
            skip: filter.offset,
            orderBy,
            orderDirection: orderDir,
            where: {
                actor: filter.bettor?.toLowerCase(),
            },
        };
        if (filter.type === BetType.Unredeemed) {
            variables.where.isRedeemable = true;
        }
        else if (filter.type === BetType.Accepted) {
            variables.where.status = GraphBetStatus.Accepted;
        }
        else if (filter.type === BetType.Settled) {
            variables.where.status_in = [GraphBetStatus.Resolved, GraphBetStatus.Canceled];
            variables.where.isRedeemable = false;
        }
        if (filter.affiliate) {
            variables.where.affiliate = filter.affiliate;
        }
        return {
            variables,
            ssr: false,
            client: prematchClient,
            skip: !filter.bettor,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        filter.limit,
        filter.offset,
        filter.bettor,
        filter.type,
        filter.affiliate,
        orderBy,
        orderDir,
    ]);
    const { data, loading, error } = useQuery$1(PrematchBetsDocument, options);
    const bets = useMemo(() => {
        if (!data?.bets?.length) {
            return [];
        }
        return data.bets.map((rawBet) => {
            const { tokenId, status, amount, odds, settledOdds, createdAt, result, affiliate, core: { address: coreAddress, liquidityPool: { address: lpAddress } }, payout: _payout, isRedeemed: _isRedeemed, isRedeemable, freebet, txHash, selections, } = rawBet;
            const isWin = result === BetResult.Won;
            const isLose = result === BetResult.Lost;
            const isCanceled = status === GraphBetStatus.Canceled;
            // express bets have a specific feature - protocol redeems LOST expresses to release liquidity,
            // so we should validate it by "win"/"canceled" statuses
            const isRedeemed = (isWin || isCanceled) && _isRedeemed;
            const isFreebet = Boolean(freebet);
            const freebetId = freebet?.freebetId;
            const freebetContractAddress = freebet?.contractAddress;
            const payout = isRedeemable && isWin ? +_payout : null;
            const betDiff = isFreebet ? amount : 0; // for freebet we must exclude bonus value from possible win
            const totalOdds = settledOdds ? +settledOdds : +odds;
            const possibleWin = +amount * totalOdds - +betDiff;
            const outcomes = selections
                .map((selection) => {
                const { odds, result, outcome: { outcomeId, title: customSelectionName, condition: { conditionId, status: conditionStatus, title: customMarketName, game, }, }, } = selection;
                const isWin = result ? result === SelectionResult.Won : null;
                const isLose = result ? result === SelectionResult.Lost : null;
                const isCanceled = (conditionStatus === ConditionStatus.Canceled
                    || game.status === PrematchGraphGameStatus.Canceled);
                const marketName = customMarketName && customMarketName !== 'null' ? customMarketName : getMarketName({ outcomeId });
                const selectionName = customSelectionName && customSelectionName !== 'null' ? customSelectionName : getSelectionName({ outcomeId, withPoint: true });
                return {
                    selectionName,
                    outcomeId,
                    conditionId,
                    coreAddress,
                    odds: +odds,
                    marketName,
                    game,
                    isWin,
                    isLose,
                    isCanceled,
                };
            })
                .sort((a, b) => +a.game.startsAt - +b.game.startsAt);
            const bet = {
                affiliate: affiliate,
                tokenId,
                freebetContractAddress: freebetContractAddress,
                freebetId,
                txHash,
                totalOdds,
                status,
                amount,
                possibleWin,
                payout,
                createdAt: +createdAt,
                isWin,
                isLose,
                isRedeemable,
                isRedeemed,
                isCanceled,
                coreAddress: coreAddress,
                lpAddress: lpAddress,
                outcomes,
                isLive: false,
            };
            return bet;
        });
    }, [data]);
    return {
        loading,
        bets,
        error,
    };
};const useLiveBets = (props) => {
    const { filter, orderBy = Bet_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Asc, } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const [bets, setBets] = useState([]);
    const [isGamesFetching, setGamesFetching] = useState(true);
    const options = useMemo(() => {
        const variables = {
            first: filter.limit || 1000,
            skip: filter.offset,
            orderBy,
            orderDirection: orderDir,
            where: {
                actor: filter.bettor?.toLowerCase(),
            },
        };
        if (filter.type === BetType.Unredeemed) {
            variables.where.isRedeemable = true;
        }
        else if (filter.type === BetType.Accepted) {
            variables.where.status = GraphBetStatus.Accepted;
        }
        else if (filter.type === BetType.Settled) {
            variables.where.status_in = [GraphBetStatus.Resolved, GraphBetStatus.Canceled];
            variables.where.isRedeemable = false;
        }
        if (filter.affiliate) {
            variables.where.affiliate = filter.affiliate;
        }
        return {
            variables,
            ssr: false,
            client: prematchClient,
            skip: !filter.bettor,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        filter.limit,
        filter.offset,
        filter.bettor,
        filter.type,
        filter.affiliate,
        orderBy,
        orderDir,
    ]);
    const { data, loading: isBetsFetching, error } = useQuery$1(LiveBetsDocument, options);
    const { liveBets } = data || { liveBets: [] };
    const formattedBets = useMemo(() => {
        if (!liveBets.length) {
            return [];
        }
        return liveBets.map((rawBet) => {
            const { tokenId, status, amount, odds, settledOdds, createdAt, result, affiliate, core: { address: coreAddress, liquidityPool: { address: lpAddress } }, payout: _payout, isRedeemed: _isRedeemed, isRedeemable, txHash, selections, } = rawBet;
            const isWin = result === BetResult.Won;
            const isLose = result === BetResult.Lost;
            const isCanceled = status === GraphBetStatus.Canceled;
            // express bets have a specific feature - protocol redeems LOST expresses to release liquidity,
            // so we should validate it by "win"/"canceled" statuses
            const isRedeemed = (isWin || isCanceled) && _isRedeemed;
            const payout = isRedeemable && isWin ? +_payout : null;
            const totalOdds = settledOdds ? +settledOdds : +odds;
            const possibleWin = +amount * totalOdds;
            const outcomes = selections
                .map((selection) => {
                const { odds, result, outcome: { outcomeId, condition: { conditionId, status: conditionStatus, gameId } } } = selection;
                const isWin = result ? result === SelectionResult.Won : null;
                const isLose = result ? result === SelectionResult.Lost : null;
                const isCanceled = conditionStatus === ConditionStatus.Canceled;
                const marketName = getMarketName({ outcomeId });
                const selectionName = getSelectionName({ outcomeId, withPoint: true });
                return {
                    selectionName,
                    outcomeId,
                    conditionId,
                    coreAddress,
                    odds: +odds,
                    marketName,
                    gameId,
                    isWin,
                    isLose,
                    isCanceled,
                };
            });
            const bet = {
                affiliate: affiliate,
                tokenId,
                txHash,
                totalOdds,
                status,
                amount,
                possibleWin,
                payout,
                createdAt: +createdAt,
                isWin,
                isLose,
                isRedeemable,
                isRedeemed,
                isCanceled,
                coreAddress: coreAddress,
                lpAddress: lpAddress,
                outcomes,
                isLive: true,
            };
            return bet;
        });
    }, [liveBets]);
    useEffect(() => {
        if (!formattedBets.length) {
            setGamesFetching(false);
            return;
        }
        (async () => {
            let games = {};
            const needToGetGames = new Set();
            formattedBets.forEach(({ outcomes }) => {
                const gameId = outcomes[0]?.gameId;
                const game = liveClient.cache.readFragment({
                    id: liveClient.cache.identify({ __typename: 'Game', id: gameId }),
                    fragment: MainGameInfoFragmentDoc,
                    fragmentName: 'MainGameInfo',
                });
                if (game) {
                    games[gameId] = game;
                }
                else {
                    needToGetGames.add(gameId);
                }
            });
            if (needToGetGames.size) {
                const { data: { games: _games } } = await liveClient.query({
                    query: GamesDocument,
                    variables: {
                        where: {
                            gameId_in: [...needToGetGames],
                        },
                    },
                    fetchPolicy: 'network-only',
                });
                const fetchedGames = _games.reduce((acc, game) => {
                    acc[game.gameId] = game;
                    return acc;
                }, {});
                games = {
                    ...games,
                    ...fetchedGames,
                };
            }
            const betsWithGames = formattedBets.map(bet => {
                const gameId = bet.outcomes[0]?.gameId;
                const game = games[gameId];
                if (game) {
                    return {
                        ...bet,
                        outcomes: [{
                                ...bet.outcomes[0],
                                game,
                            }],
                    };
                }
            }).filter(Boolean);
            setGamesFetching(false);
            setBets(betsWithGames);
        })();
        return () => {
            setBets([]);
        };
    }, [formattedBets]);
    return {
        loading: isBetsFetching || isGamesFetching,
        bets,
        error,
    };
};const defaultQueryProps = {
    pollInterval: undefined,
    skip: false,
};
const useConditions = (props) => {
    const { gameId, filter, prematchQuery = defaultQueryProps, liveQuery = defaultQueryProps } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const { appChain } = useChain();
    const variables = useMemo(() => {
        const vars = {
            where: {
                game_: {
                    gameId,
                },
                ...(filter || {}),
            },
        };
        return vars;
    }, [gameId, filter]);
    const { data: prematchData, loading: isPrematchLoading, error: prematchError, } = useQuery$1(PrematchConditionsDocument, {
        variables: variables,
        ssr: false,
        client: prematchClient,
        notifyOnNetworkStatusChange: true,
        ...prematchQuery,
    });
    const { data: liveData, loading: isLiveLoading, error: liveError, } = useQuery$1(LiveConditionsDocument, {
        variables: variables,
        ssr: false,
        client: liveClient,
        ...liveQuery,
        skip: liveQuery.skip || !liveSupportedChains.includes(appChain.id),
    });
    return {
        prematchConditions: prematchData?.conditions,
        liveConditions: liveData?.conditions,
        loading: isPrematchLoading || isLiveLoading,
        error: prematchError || liveError,
    };
};const useActiveConditions = (props) => {
    const { gameId, isLive, livePollInterval, filter, fetchPolicy } = props;
    const conditionsFilter = useMemo(() => {
        const _filter = {
            status_not: ConditionStatus.Resolved,
        };
        if (filter?.outcomeIds) {
            _filter.outcomesIds_contains = filter.outcomeIds;
        }
        if (filter?.maxMargin) {
            _filter.margin_lte = parseUnits(String(filter.maxMargin), MARGIN_DECIMALS).toString();
            _filter.status = ConditionStatus.Created;
        }
        return _filter;
    }, [filter?.outcomeIds, filter?.maxMargin]);
    const { prematchConditions, liveConditions, loading, error } = useConditions({
        gameId,
        filter: conditionsFilter,
        prematchQuery: {
            skip: isLive,
            fetchPolicy,
        },
        liveQuery: {
            pollInterval: livePollInterval,
            skip: !isLive,
            fetchPolicy,
        },
    });
    const conditions = isLive ? liveConditions : prematchConditions;
    return {
        conditions,
        loading,
        error,
    };
};const useGame = (props) => {
    const { gameId } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const variables = useMemo(() => ({
        gameId: gameId,
    }), [gameId]);
    const { data: prematchData, loading: isPrematchLoading, error: prematchError } = useQuery$1(GameDocument, {
        variables,
        ssr: false,
        client: prematchClient,
        skip: !gameId,
    });
    const prematchGame = prematchData?.games?.[0];
    const isPrematchGameStarted = prematchGame ? (Date.now() >= +prematchGame.startsAt * 1000) : !isPrematchLoading;
    const { data: liveData, loading: isLiveLoading, error: liveError } = useQuery$1(GameDocument, {
        variables,
        ssr: false,
        client: liveClient,
        skip: !gameId || !isPrematchGameStarted,
    });
    const liveGame = liveData?.games?.[0];
    const game = liveGame || prematchGame;
    const isGameInLive = Boolean(liveGame);
    return {
        game,
        loading: isPrematchLoading || isLiveLoading,
        error: prematchError || liveError,
        isGameInLive,
    };
};const useActiveMarkets = (props) => {
    const { gameId, gameStatus, filter, livePollInterval, fetchPolicy } = props;
    const { loading, conditions, error } = useActiveConditions({
        gameId,
        filter,
        isLive: gameStatus === GameStatus.Live,
        livePollInterval,
        fetchPolicy,
    });
    // generate unique key for memo deps
    const conditionIds = conditions?.map(({ id, outcomes }) => `${id}-${outcomes.length}`).join('_');
    const markets = useMemo(() => {
        if (!conditions?.length) {
            return [];
        }
        return groupConditionsByMarket(conditions);
    }, [conditionIds]);
    return {
        loading,
        markets,
        error,
    };
};const useResolvedMarkets = (props) => {
    const { gameId } = props;
    const { loading, liveConditions, prematchConditions, error } = useConditions({
        gameId,
        filter: {
            status: ConditionStatus.Resolved,
        },
    });
    const prematchConditionIds = prematchConditions?.map(({ id, outcomes }) => `${id}-${outcomes.length}`).join('_');
    const liveConditionIds = liveConditions?.map(({ id, outcomes }) => `${id}-${outcomes.length}`).join('_');
    const prematchMarkets = useMemo(() => {
        if (!prematchConditions?.length) {
            return [];
        }
        return groupConditionsByMarket(prematchConditions);
    }, [prematchConditionIds]);
    const liveMarkets = useMemo(() => {
        if (!liveConditions?.length) {
            return [];
        }
        return groupConditionsByMarket(liveConditions);
    }, [liveConditionIds]);
    const groupedMarkets = useMemo(() => {
        if (!prematchMarkets?.length || !liveMarkets?.length) {
            if (prematchMarkets?.length) {
                return prematchMarkets;
            }
            if (liveMarkets?.length) {
                return liveMarkets;
            }
        }
        return Object.values([...liveMarkets, ...prematchMarkets].reduce((acc, market) => {
            const { marketKey } = market;
            if (!acc[marketKey]) {
                acc[marketKey] = market;
            }
            return acc;
        }, {}));
    }, [prematchMarkets, liveMarkets]);
    return {
        groupedMarkets,
        prematchMarkets,
        liveMarkets,
        loading,
        error,
    };
};const useGames = (props) => {
    const { filter, orderBy = Game_OrderBy.CreatedBlockTimestamp, orderDir = OrderDirection.Desc, isLive, } = props || {};
    const { prematchClient, liveClient } = useApolloClients();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: 1000,
            orderBy,
            orderDirection: orderDir,
            where: {
                hasActiveConditions: true,
                status_in: [PrematchGraphGameStatus.Created, PrematchGraphGameStatus.Paused],
                conditions_: {},
                sport_: {},
                league_: {},
            },
        };
        if (isLive) {
            variables.where.startsAt_lt = startsAt;
        }
        else {
            variables.where.startsAt_gt = startsAt;
        }
        if (filter?.limit) {
            variables.first = filter.limit;
        }
        if (filter?.offset) {
            variables.skip = filter.offset;
        }
        if (filter?.sportHub) {
            variables.where.sport_.sporthub = filter.sportHub;
        }
        if (filter?.sportSlug) {
            variables.where.sport_.slug_starts_with_nocase = filter.sportSlug;
        }
        if (filter?.sportIds?.length) {
            variables.where.sport_.sportId_in = filter?.sportIds;
        }
        if (filter?.leagueSlug) {
            variables.where.league_.slug_in = typeof filter.leagueSlug === 'string' ? [filter.leagueSlug] : filter.leagueSlug;
        }
        if (filter?.maxMargin) {
            variables.where.conditions_.margin_lte = parseUnits(String(filter.maxMargin), MARGIN_DECIMALS).toString();
        }
        if (filter?.conditionsStatus) {
            if (typeof filter.conditionsStatus === 'string') {
                variables.where.conditions_.status = filter.conditionsStatus;
            }
            else {
                variables.where.conditions_.status_in = filter.conditionsStatus;
            }
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        filter?.limit,
        filter?.offset,
        filter?.sportHub,
        filter?.sportSlug,
        filter?.sportIds?.join('-'),
        filter?.leagueSlug,
        filter?.maxMargin,
        filter?.conditionsStatus,
        orderBy,
        orderDir,
        startsAt,
        isLive,
    ]);
    const { data, loading, error } = useQuery$1(GamesDocument, options);
    return {
        games: data?.games,
        loading,
        error,
    };
};const useSports = (props) => {
    const { filter, gameOrderBy = Game_OrderBy.StartsAt, orderDir = OrderDirection.Asc, isLive, } = props || {};
    const { prematchClient, liveClient } = useApolloClients();
    const { contracts } = useChain();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: filter?.limit || 1000,
            sportFilter: {},
            countryFilter: {},
            leagueFilter: {},
            gameFilter: {
                hasActiveConditions: true,
                status_in: [PrematchGraphGameStatus.Created, PrematchGraphGameStatus.Paused],
            },
            gameOrderBy,
            gameOrderDirection: orderDir,
        };
        if (filter?.sportSlug) {
            variables.sportFilter.slug = filter.sportSlug;
        }
        if (filter?.sportHub) {
            variables.sportFilter.sporthub = filter.sportHub;
        }
        if (filter?.sportIds?.length) {
            variables.sportFilter.sportId_in = filter?.sportIds;
        }
        if (filter?.countrySlug) {
            variables.countryFilter.slug = filter.countrySlug;
        }
        if (isLive) {
            variables.gameFilter.startsAt_lt = startsAt;
        }
        else {
            variables.gameFilter.startsAt_gt = startsAt;
        }
        variables.leagueFilter.games_ = variables.gameFilter;
        if (filter?.leagueSlug) {
            variables.leagueFilter.slug = filter.leagueSlug;
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        isLive,
        gameOrderBy,
        orderDir,
        startsAt,
        filter?.limit,
        filter?.sportHub,
        filter?.sportSlug,
        filter?.countrySlug,
        filter?.leagueSlug,
        filter?.sportIds?.join('-'),
    ]);
    if (!isLive) {
        options.variables.gameFilter.liquidityPool = contracts.lp.address.toLowerCase();
    }
    const { data, loading, error } = useQuery$1(SportsDocument, options);
    const { sports } = data || { sports: [] };
    const formattedSports = useMemo(() => {
        if (!sports.length) {
            return [];
        }
        const filteredSports = sports.map(sport => {
            const { countries } = sport;
            const filteredCountries = countries.filter(({ leagues }) => leagues.length);
            return {
                ...sport,
                countries: filteredCountries,
            };
        }).filter(sport => sport.countries.length);
        if (gameOrderBy === Game_OrderBy.Turnover) {
            const sportsWithTurnover = filteredSports.map(sport => {
                const { countries } = sport;
                const turnover = countries.reduce((acc, { turnover }) => {
                    acc += +turnover;
                    return acc;
                }, 0);
                return {
                    ...sport,
                    turnover,
                };
            });
            return sportsWithTurnover.sort((a, b) => b.turnover - a.turnover);
        }
        if (gameOrderBy === Game_OrderBy.StartsAt) {
            return filteredSports.map(sport => {
                const { countries } = sport;
                const sortedCountries = countries.map(country => {
                    const { leagues } = country;
                    return {
                        ...country,
                        leagues: [...leagues].sort((a, b) => +a.games[0].startsAt - +b.games[0].startsAt),
                    };
                }).sort((a, b) => +a.leagues[0].games[0].startsAt - +b.leagues[0].games[0].startsAt);
                return {
                    ...sport,
                    countries: sortedCountries,
                };
            }).sort((a, b) => +a.countries[0].leagues[0].games[0].startsAt - +b.countries[0].leagues[0].games[0].startsAt);
        }
        return filteredSports;
    }, [sports]);
    return {
        loading,
        sports: formattedSports,
        error,
    };
};const useSportsNavigation = (props = {}) => {
    const { filter, withGameCount = false, isLive } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: 1000,
            withGameCount,
            sportFilter: {},
            gameFilter: {
                hasActiveConditions: true,
                status_in: [PrematchGraphGameStatus.Created, PrematchGraphGameStatus.Paused],
            },
        };
        if (isLive) {
            variables.gameFilter.startsAt_lt = startsAt;
        }
        else {
            variables.gameFilter.startsAt_gt = startsAt;
        }
        if (filter?.sportHub) {
            variables.sportFilter.sporthub = filter.sportHub;
        }
        if (filter?.sportIds?.length) {
            variables.sportFilter.sportId_in = filter?.sportIds;
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        withGameCount,
        startsAt,
        isLive,
        filter?.sportHub,
        filter?.sportIds?.join('-'),
    ]);
    const { data, loading, error } = useQuery$1(SportsNavigationDocument, options);
    return {
        sports: data?.sports,
        loading,
        error,
    };
};const useNavigation = (props = {}) => {
    const { filter, withGameCount = false, isLive } = props;
    const { prematchClient, liveClient } = useApolloClients();
    const startsAt = getGameStartsAtValue();
    const options = useMemo(() => {
        const variables = {
            first: 1000,
            withGameCount,
            sportFilter: {},
            gameFilter: {
                hasActiveConditions: true,
                status_in: [PrematchGraphGameStatus.Created, PrematchGraphGameStatus.Paused],
            },
        };
        if (isLive) {
            variables.gameFilter.startsAt_lt = startsAt;
        }
        else {
            variables.gameFilter.startsAt_gt = startsAt;
        }
        if (filter?.sportHub) {
            variables.sportFilter.sporthub = filter.sportHub;
        }
        if (filter?.sportIds?.length) {
            variables.sportFilter.sportId_in = filter?.sportIds;
        }
        return {
            variables,
            ssr: false,
            client: isLive ? liveClient : prematchClient,
            notifyOnNetworkStatusChange: true,
        };
    }, [
        withGameCount,
        startsAt,
        isLive,
        filter?.sportHub,
        filter?.sportIds?.join('-'),
    ]);
    const { data, loading, error } = useQuery$1(NavigationDocument, options);
    return {
        navigation: data?.sports,
        loading,
        error,
    };
};const useLiveBetFee = ({ enabled } = { enabled: true }) => {
    const { appChain } = useChain();
    const queryFn = async () => {
        const { gasAmount, relayerFeeAmount, beautyRelayerFeeAmount, } = await getLiveBetFee(appChain.id);
        return {
            gasAmount: BigInt(gasAmount),
            relayerFeeAmount: BigInt(relayerFeeAmount),
            formattedRelayerFeeAmount: beautyRelayerFeeAmount,
        };
    };
    let { isFetching, data, refetch } = useQuery({
        queryKey: ['/live-bet-fee', appChain.id],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
        refetchInterval: 10000,
    });
    if (!enabled) {
        data = undefined;
    }
    return {
        gasAmount: data?.gasAmount,
        relayerFeeAmount: data?.relayerFeeAmount,
        formattedRelayerFeeAmount: data?.formattedRelayerFeeAmount,
        refetch,
        loading: isFetching,
    };
};const useBetsSummary = (props) => {
    const { account, affiliates } = props;
    const { betToken } = useChain();
    const { prematchClient } = useApolloClients();
    const options = useMemo(() => {
        const variables = {
            where: {
                address: account?.toLowerCase(),
            },
        };
        if (affiliates?.length) {
            variables.where.affiliate_in = affiliates.map(affiliate => affiliate.toLowerCase());
        }
        return {
            variables,
            ssr: false,
            client: prematchClient,
            notifyOnNetworkStatusChange: true,
            skip: !account,
        };
    }, [
        account,
        affiliates?.join('-'),
    ]);
    const { data, loading, error } = useQuery$1(BettorsDocument, options);
    const { bettors } = data || { bettors: [] };
    const formattedData = useMemo(() => {
        if (!bettors.length) {
            return {
                toPayout: '0',
                inBets: '0',
                totalPayout: '0',
                totalProfit: '0',
                betsCount: 0,
                wonBetsCount: 0,
                lostBetsCount: 0,
            };
        }
        const { rawToPayout, rawInBets, rawTotalPayout, rawTotalProfit, betsCount, wonBetsCount, lostBetsCount, } = bettors.reduce((acc, bettor) => {
            const { rawToPayout, rawInBets, rawTotalPayout, rawTotalProfit, betsCount, wonBetsCount, lostBetsCount } = bettor;
            acc.rawToPayout += BigInt(rawToPayout);
            acc.rawInBets += BigInt(rawInBets);
            acc.rawTotalPayout += BigInt(rawTotalPayout);
            acc.rawTotalProfit += BigInt(rawTotalProfit);
            acc.betsCount += betsCount;
            acc.wonBetsCount += wonBetsCount;
            acc.lostBetsCount += lostBetsCount;
            return acc;
        }, {
            rawToPayout: 0n,
            rawInBets: 0n,
            rawTotalPayout: 0n,
            rawTotalProfit: 0n,
            betsCount: 0,
            wonBetsCount: 0,
            lostBetsCount: 0,
        });
        return {
            toPayout: formatUnits(rawToPayout, betToken.decimals),
            inBets: formatUnits(rawInBets, betToken.decimals),
            totalPayout: formatUnits(rawTotalPayout, betToken.decimals),
            totalProfit: formatUnits(rawTotalProfit, betToken.decimals),
            betsCount,
            wonBetsCount,
            lostBetsCount,
        };
    }, [data]);
    return {
        ...formattedData,
        loading,
        error,
    };
};const DIVIDER = 18;
const useBetsSummaryBySelection = ({ account, gameId, gameStatus, keyStruct = 'outcomeId' }) => {
    const { prematchClient } = useApolloClients();
    const { betToken } = useChain();
    const variables = useMemo(() => ({
        actor: account?.toLowerCase(),
        gameId,
    }), [account, gameId]);
    const { data, loading, error } = useQuery$1(GameBetsDocument, {
        variables,
        ssr: false,
        client: prematchClient,
        skip: !account || gameStatus !== GameStatus.Resolved,
    });
    const { bets: prematchBets, liveBets } = data || {};
    const betsSummary = useMemo(() => {
        if (!prematchBets?.length && !liveBets?.length) {
            return {};
        }
        const rawOne = parseUnits('1', ODDS_DECIMALS);
        const rawSummary = [...(prematchBets || []), ...(liveBets || [])].reduce((acc, bet) => {
            const { rawAmount: _rawAmount, rawPotentialPayout: _rawPotentialPayout, result, selections } = bet;
            const { freebet } = bet;
            const isExpress = selections.length > 1;
            const isWin = result === BetResult.Won;
            const rawAmount = BigInt(_rawAmount);
            const rawBetDiff = freebet ? rawAmount : 0n;
            const rawPayout = BigInt(_rawPotentialPayout) - rawBetDiff;
            let rawOddsSummary = 0n;
            if (isExpress) {
                selections.forEach(selection => {
                    const { rawOdds } = selection;
                    rawOddsSummary += BigInt(rawOdds) - rawOne;
                });
            }
            selections.forEach(selection => {
                const { outcome: { outcomeId, condition: { conditionId } } } = selection;
                if (isExpress) {
                    const { outcome: { condition: { game: { gameId: _gameId } } } } = selection;
                    if (gameId !== _gameId) {
                        return;
                    }
                }
                let key = outcomeId;
                if (keyStruct === 'conditionId-outcomeId') {
                    key = `${conditionId}-${outcomeId}`;
                }
                if (!acc[key]) {
                    acc[key] = 0n;
                }
                if (isExpress) {
                    const { rawOdds } = selection;
                    const rawSubBetOdds = parseUnits(String(BigInt(rawOdds) - rawOne), DIVIDER);
                    const rawSubBetAmount = rawAmount * (rawSubBetOdds / rawOddsSummary);
                    acc[key] += isWin ? rawSubBetAmount * BigInt(rawOdds) : -rawSubBetAmount;
                }
                else {
                    acc[key] += parseUnits(String(isWin ? rawPayout : -rawAmount), DIVIDER);
                }
            });
            return acc;
        }, {});
        return Object.keys(rawSummary).reduce((acc, key) => {
            acc[key] = formatUnits(rawSummary[key], betToken.decimals + DIVIDER);
            return acc;
        }, {});
    }, [prematchBets, liveBets]);
    return {
        betsSummary,
        loading,
        error,
    };
};const useBetsCache = () => {
    const { prematchClient, liveClient } = useApolloClients();
    const { contracts, betToken } = useChain();
    const { address } = useExtendedAccount();
    const updateBetCache = ({ coreAddress, tokenId }, values) => {
        const isLive = contracts.liveCore ? coreAddress.toLowerCase() === contracts.liveCore.address.toLowerCase() : false;
        const { cache } = prematchClient;
        const betEntityId = `${coreAddress.toLowerCase()}_${tokenId}`;
        let bet;
        if (isLive) {
            bet = cache.updateFragment({
                id: cache.identify({ __typename: 'LiveBet', id: betEntityId }),
                fragment: LiveBetFragmentDoc,
                fragmentName: 'LiveBet',
            }, (data) => ({
                ...data,
                ...values,
            }));
        }
        else {
            bet = cache.updateFragment({
                id: cache.identify({ __typename: 'Bet', id: betEntityId }),
                fragment: PrematchBetFragmentDoc,
                fragmentName: 'PrematchBet',
            }, (data) => ({
                ...data,
                ...values,
            }));
        }
        if (!bet) {
            return;
        }
        const bettorEntity = `${contracts.lp.address.toLowerCase()}_${address.toLowerCase()}_${bet.affiliate.toLowerCase()}`;
        prematchClient.cache.updateFragment({
            id: prematchClient.cache.identify({ __typename: 'Bettor', id: bettorEntity }),
            fragment: BettorFragmentDoc,
            fragmentName: 'Bettor',
        }, (data) => {
            if (!data) {
                return data;
            }
            const rawPayout = parseUnits(bet.payout, betToken.decimals);
            const newRawToPayout = BigInt(data.rawToPayout) - rawPayout;
            return {
                ...data,
                rawToPayout: String(newRawToPayout),
            };
        });
    };
    const addBet = async (props) => {
        const { bet, odds, affiliate, receipt } = props;
        const { rawAmount, selections, freebetId } = bet;
        const coreAddress = selections[0].coreAddress;
        const isLive = coreAddress.toLowerCase() === liveHostAddress.toLowerCase();
        const client = isLive ? liveClient : prematchClient;
        const { cache } = client;
        const selectionFragments = [];
        for (let index = 0; index < selections.length; index++) {
            const { outcomeId, conditionId: _conditionId } = selections[index];
            const conditionId = String(_conditionId);
            if (isLive) {
                let condition = cache.readFragment({
                    id: cache.identify({ __typename: 'Condition', id: conditionId }),
                    fragment: LiveConditionFragmentDoc,
                    fragmentName: 'LiveCondition',
                });
                if (!condition) {
                    const { data: { condition: _condition } } = await client.query({
                        query: LiveConditionDocument,
                        variables: {
                            conditionId,
                        },
                        fetchPolicy: 'network-only',
                    });
                    condition = _condition;
                }
                const gameId = condition.game.gameId;
                const selectionFragment = {
                    __typename: 'LiveSelection',
                    odds: String(odds[`${conditionId}-${outcomeId}`]),
                    result: null,
                    outcome: {
                        __typename: 'LiveOutcome',
                        outcomeId: String(outcomeId),
                        condition: {
                            __typename: 'LiveCondition',
                            conditionId,
                            status: ConditionStatus.Created,
                            gameId,
                        },
                    },
                };
                selectionFragments.push(selectionFragment);
            }
            else {
                const conditionEntityId = `${coreAddress.toLowerCase()}_${conditionId}`;
                let condition = cache.readFragment({
                    id: cache.identify({ __typename: 'Condition', id: conditionEntityId }),
                    fragment: PrematchConditionFragmentDoc,
                    fragmentName: 'PrematchCondition',
                });
                if (!condition) {
                    const { data: { condition: _condition } } = await client.query({
                        query: PrematchConditionDocument,
                        variables: {
                            id: conditionEntityId,
                        },
                        fetchPolicy: 'network-only',
                    });
                    condition = _condition;
                }
                const outcome = condition.outcomes.find((outcome) => outcome.outcomeId === outcomeId);
                const gameId = condition?.game.gameId;
                const gameEntityId = `${contracts.lp.address.toLowerCase()}_${gameId}`;
                let game = cache.readFragment({
                    id: cache.identify({ __typename: 'Game', id: gameEntityId }),
                    fragment: MainGameInfoFragmentDoc,
                    fragmentName: 'MainGameInfo',
                });
                if (!game) {
                    const { data: { games } } = await client.query({
                        query: GameDocument,
                        variables: {
                            gameId,
                        },
                        fetchPolicy: 'network-only',
                    });
                    game = games[0];
                }
                const selectionFragment = {
                    __typename: 'Selection',
                    odds: String(odds[`${conditionId}-${outcomeId}`]),
                    result: null,
                    outcome: {
                        __typename: 'Outcome',
                        outcomeId: String(outcomeId),
                        title: outcome.title,
                        condition: {
                            __typename: 'Condition',
                            conditionId,
                            status: ConditionStatus.Created,
                            title: condition.title,
                            game,
                        },
                    },
                };
                selectionFragments.push(selectionFragment);
            }
        }
        let tokenId;
        let rawOdds = 0n;
        if (isLive) {
            const receiptArgs = getEventArgsFromTxReceipt({ receipt, eventName: 'NewLiveBet', abi: liveCoreAbi });
            tokenId = (receiptArgs?.tokenId).toString();
            rawOdds = receiptArgs?.odds;
        }
        // we don't need additional for freeBet cause it triggers NewBet event on prematch core
        else {
            const isExpress = selections.length > 1;
            if (isExpress) {
                const receiptArgs = getEventArgsFromTxReceipt({
                    receipt,
                    eventName: 'NewBet',
                    abi: contracts.prematchComboCore.abi,
                });
                tokenId = receiptArgs?.betId.toString();
                rawOdds = receiptArgs?.bet.odds;
            }
            else {
                const { conditionId, outcomeId } = selections[0];
                const eventParams = {
                    conditionId: BigInt(conditionId),
                    outcomeId: BigInt(outcomeId),
                };
                const receiptArgs = getEventArgsFromTxReceipt({
                    receipt,
                    eventName: 'NewBet',
                    abi: contracts.prematchCore.abi,
                    params: eventParams,
                });
                tokenId = receiptArgs?.tokenId.toString();
                rawOdds = receiptArgs?.odds;
            }
        }
        const rawPotentialPayout = rawAmount * rawOdds;
        const potentialPayout = formatUnits(rawPotentialPayout, betToken.decimals);
        const finalOdds = formatUnits(rawOdds, ODDS_DECIMALS);
        const amount = formatUnits(rawAmount, betToken.decimals);
        const actorArg = `"actor":"${address.toLowerCase()}"`;
        const affiliateArg = `"affiliate":"${affiliate}"`;
        if (isLive) {
            prematchClient.cache.modify({
                id: prematchClient.cache.identify({ __typename: 'Query' }),
                fields: {
                    liveBets: (bets, { storeFieldName }) => {
                        const isValidStorage = (storeFieldName.includes(`{${actorArg}}`) // all bets
                            || storeFieldName.includes(`{${actorArg},${affiliateArg}}`) // all bets with affiliate
                            || (storeFieldName.includes(actorArg) && storeFieldName.includes('"status":"Accepted"')) // BetType.Accepted
                        );
                        if (!isValidStorage) {
                            return bets;
                        }
                        const betEntityId = `${coreAddress.toLowerCase()}_${tokenId}`;
                        const data = {
                            __typename: 'LiveBet',
                            id: betEntityId,
                            tokenId: tokenId,
                            core: {
                                address: coreAddress,
                                liquidityPool: {
                                    address: contracts.lp.address,
                                },
                            },
                            status: GraphBetStatus.Accepted,
                            amount,
                            odds: finalOdds,
                            settledOdds: null,
                            createdAt: String(Math.floor(Date.now() / 1000)),
                            payout: null,
                            potentialPayout: potentialPayout,
                            isRedeemed: false,
                            isRedeemable: false,
                            result: null,
                            txHash: receipt.transactionHash,
                            affiliate,
                            selections: selectionFragments,
                        };
                        const newBet = prematchClient.cache.writeFragment({
                            fragment: LiveBetFragmentDoc,
                            fragmentName: 'LiveBet',
                            data,
                        });
                        return [newBet, ...bets];
                    },
                },
            });
        }
        else {
            prematchClient.cache.modify({
                id: prematchClient.cache.identify({ __typename: 'Query' }),
                fields: {
                    bets: (bets, { storeFieldName }) => {
                        const isValidStorage = (storeFieldName.includes(`{${actorArg}}`) // all bets
                            || storeFieldName.includes(`{${actorArg},${affiliateArg}}`) // all bets with affiliate
                            || (storeFieldName.includes(actorArg) && storeFieldName.includes('"status":"Accepted"')) // BetType.Accepted
                        );
                        if (!isValidStorage) {
                            return bets;
                        }
                        const betEntityId = `${coreAddress.toLowerCase()}_${tokenId}`;
                        const data = {
                            __typename: 'Bet',
                            id: betEntityId,
                            tokenId: tokenId,
                            core: {
                                address: coreAddress,
                                liquidityPool: {
                                    address: contracts.lp.address,
                                },
                            },
                            status: GraphBetStatus.Accepted,
                            amount,
                            odds: finalOdds,
                            settledOdds: null,
                            createdAt: String(Math.floor(Date.now() / 1000)),
                            payout: null,
                            potentialPayout: potentialPayout,
                            isRedeemed: false,
                            isRedeemable: false,
                            freebet: bet.freebetContractAddress ? {
                                freebetId: String(freebetId),
                                contractAddress: bet.freebetContractAddress,
                            } : null,
                            result: null,
                            txHash: receipt.transactionHash,
                            affiliate,
                            selections: selectionFragments,
                        };
                        const newBet = prematchClient.cache.writeFragment({
                            fragment: PrematchBetFragmentDoc,
                            fragmentName: 'PrematchBet',
                            data,
                        });
                        return [newBet, ...bets];
                    },
                },
            });
        }
        const bettorEntity = `${contracts.lp.address.toLowerCase()}_${address.toLowerCase()}_${affiliate.toLowerCase()}`;
        const bettorFragment = cache.readFragment({
            id: cache.identify({ __typename: 'Bettor', id: bettorEntity }),
            fragment: BettorFragmentDoc,
            fragmentName: 'Bettor',
        });
        if (bettorFragment) {
            prematchClient.cache.updateFragment({
                id: prematchClient.cache.identify({ __typename: 'Bettor', id: bettorEntity }),
                fragment: BettorFragmentDoc,
                fragmentName: 'Bettor',
            }, (data) => ({
                ...data,
                betsCount: data.betsCount + 1,
                rawInBets: String(BigInt(data.rawInBets) + rawAmount),
            }));
        }
        else {
            prematchClient.cache.modify({
                id: prematchClient.cache.identify({ __typename: 'Query' }),
                fields: {
                    bettors: (bettors) => {
                        const newBettor = prematchClient.cache.writeFragment({
                            fragment: BettorFragmentDoc,
                            fragmentName: 'Bettor',
                            data: {
                                __typename: 'Bettor',
                                id: bettorEntity,
                                rawToPayout: '0',
                                rawInBets: String(rawAmount),
                                rawTotalPayout: '0',
                                rawTotalProfit: '0',
                                betsCount: 1,
                                wonBetsCount: 0,
                                lostBetsCount: 0,
                            },
                        });
                        return [...bettors, newBettor];
                    },
                },
            });
        }
    };
    return {
        updateBetCache,
        addBet,
    };
};const useRedeemBet = () => {
    const publicClient = usePublicClient();
    const { contracts, appChain } = useChain();
    const { updateBetCache } = useBetsCache();
    const redeemTx = useSendTransaction();
    const account = useExtendedAccount();
    const isAAWallet = Boolean(account.isAAWallet);
    const aaClient = useAAWalletClient();
    const [aaTxState, setAaTxState] = useState({ isPending: false, data: undefined, error: null });
    const receipt = useWaitForTransactionReceipt({
        hash: aaTxState.data || redeemTx.data,
    });
    const submit = async (props) => {
        const { bets } = props;
        const isBatch = bets.length > 1;
        redeemTx.reset();
        setAaTxState({
            isPending: isAAWallet,
            data: undefined,
            error: null,
        });
        let data;
        let to;
        if (isBatch) {
            const betsData = bets.map(({ tokenId, coreAddress }) => ({
                core: coreAddress,
                tokenId: BigInt(tokenId),
                isNative: false,
            }));
            to = contracts.proxyFront.address;
            data = encodeFunctionData({
                abi: contracts.proxyFront.abi,
                functionName: 'withdrawPayouts',
                args: [betsData],
            });
        }
        else {
            const { tokenId, coreAddress, freebetContractAddress, freebetId } = bets[0];
            if (freebetContractAddress && freebetId) {
                to = freebetContractAddress;
                data = encodeFunctionData({
                    abi: freeBetAbi,
                    functionName: 'withdrawPayout',
                    args: [BigInt(freebetId)],
                });
            }
            else {
                to = contracts.lp.address;
                data = encodeFunctionData({
                    abi: contracts.lp.abi,
                    functionName: 'withdrawPayout',
                    args: [
                        coreAddress,
                        BigInt(tokenId),
                    ],
                });
            }
        }
        let hash;
        if (isAAWallet) {
            try {
                hash = await aaClient.sendTransaction({ to, data, chain: appChain });
                setAaTxState({
                    data: hash,
                    isPending: false,
                    error: null,
                });
            }
            catch (error) {
                setAaTxState({
                    data: undefined,
                    isPending: false,
                    error,
                });
                throw error;
            }
        }
        else {
            hash = await redeemTx.sendTransactionAsync({ to, data });
        }
        const receipt = await publicClient.waitForTransactionReceipt({
            hash,
        });
        bets.forEach(({ tokenId, coreAddress }) => {
            updateBetCache({
                coreAddress,
                tokenId,
            }, {
                isRedeemed: true,
                isRedeemable: false,
            });
        });
        return receipt;
    };
    return {
        isPending: redeemTx.isPending || aaTxState.isPending,
        isProcessing: receipt.isLoading,
        data: redeemTx.data || aaTxState.data,
        error: redeemTx.error || aaTxState.error,
        submit,
    };
};const useBetTokenBalance = () => {
    const { appChain, betToken } = useChain();
    const { address } = useExtendedAccount();
    const formatBalance = useCallback((rawBalance) => ({
        rawBalance,
        balance: formatUnits(rawBalance, betToken.decimals),
    }), [betToken.decimals]);
    const { data, isLoading, error, refetch } = useReadContract({
        address: betToken.address,
        abi: erc20Abi,
        functionName: 'balanceOf',
        chainId: appChain.id,
        args: [address],
        query: {
            enabled: Boolean(address),
            select: formatBalance,
        },
    });
    return {
        refetch,
        loading: isLoading,
        rawBalance: data?.rawBalance,
        balance: data?.balance,
        error,
    };
};const useNativeBalance = () => {
    const { appChain } = useChain();
    const { address } = useExtendedAccount();
    const formatBalance = useCallback((data) => ({
        rawBalance: data.value,
        balance: formatUnits(data.value, data.decimals),
    }), []);
    const { isLoading, data, error, refetch } = useBalance({
        chainId: appChain.id,
        address,
        query: {
            enabled: Boolean(address),
            select: formatBalance,
        },
    });
    return {
        loading: isLoading,
        rawBalance: data?.rawBalance,
        balance: data?.balance,
        error,
        refetch,
    };
};const simpleObjReducer = (state, newState) => ({
    ...state,
    ...newState,
});
const usePrepareBet = (props) => {
    const { betAmount: _betAmount, slippage, deadline, affiliate, selections, odds, totalOdds, freeBet, betGas, liveEIP712Attention, onSuccess, onError, } = props;
    const isLiveBet = useMemo(() => {
        return selections.some(({ coreAddress }) => coreAddress === liveHostAddress);
    }, [selections]);
    const isCombo = !isLiveBet && selections.length > 1;
    const isBatch = isCombo && typeof _betAmount === 'object';
    const isFreeBet = Boolean(freeBet) && !isCombo && !isBatch;
    const account = useExtendedAccount();
    const isAAWallet = Boolean(account.isAAWallet);
    const aaClient = useAAWalletClient();
    const queryClient = useQueryClient();
    const publicClient = usePublicClient();
    const walletClient = useWalletClient();
    const { appChain, contracts, betToken, api } = useChain();
    const { relayerFeeAmount: rawRelayerFeeAmount, formattedRelayerFeeAmount: relayerFeeAmount, loading: isRelayerFeeFetching, } = useLiveBetFee({
        enabled: isLiveBet,
    });
    const { addBet } = useBetsCache();
    const { refetch: refetchBetTokenBalance } = useBetTokenBalance();
    const { refetch: refetchNativeBalance } = useNativeBalance();
    const [liveOrAABetTx, updateLiveOrAABetTx] = useReducer(simpleObjReducer, { data: undefined, isPending: false });
    const approveAddress = isLiveBet ? contracts.liveRelayer?.address : contracts.proxyFront.address;
    const allowanceTx = useReadContract({
        chainId: appChain.id,
        address: betToken.address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [
            account.address,
            approveAddress,
        ],
        query: {
            enabled: Boolean(account.address) && Boolean(approveAddress) && !isFreeBet,
        },
    });
    const approveTx = useWriteContract();
    const approveReceipt = useWaitForTransactionReceipt({
        hash: approveTx.data,
    });
    const betAmount = useMemo(() => {
        if (typeof _betAmount === 'string') {
            return +_betAmount;
        }
        return Object.values(_betAmount).reduce((acc, amount) => acc + +amount, 0);
    }, [_betAmount]);
    const isApproveRequired = useMemo(() => {
        if (!betAmount
            || typeof allowanceTx?.data === 'undefined'
            || (isLiveBet && typeof relayerFeeAmount === 'undefined')) {
            return false;
        }
        let approveAmount = betAmount;
        if (isLiveBet) {
            approveAmount += +relayerFeeAmount;
        }
        return allowanceTx.data < parseUnits(String(approveAmount), betToken.decimals);
    }, [allowanceTx.data, isLiveBet, relayerFeeAmount, betAmount]);
    const approve = async () => {
        const hash = await approveTx.writeContractAsync({
            address: betToken.address,
            abi: erc20Abi,
            functionName: 'approve',
            args: [
                approveAddress,
                maxUint256,
            ],
        });
        await publicClient.waitForTransactionReceipt({
            hash,
        });
        allowanceTx.refetch();
    };
    const betTx = useSendTransaction();
    const betReceipt = useWaitForTransactionReceipt({
        hash: betTx.data || liveOrAABetTx.data,
    });
    const placeBet = async () => {
        if (!totalOdds) {
            return;
        }
        let bets = [];
        const fixedAmount = parseFloat(String(betAmount)).toFixed(betToken.decimals);
        const rawAmount = parseUnits(fixedAmount, betToken.decimals);
        const rawDeadline = BigInt(Math.floor(Date.now() / 1000) + (deadline || DEFAULT_DEADLINE));
        let txHash;
        betTx.reset();
        updateLiveOrAABetTx({
            data: undefined,
            isPending: isLiveBet || isAAWallet,
        });
        if (isAAWallet && aaClient) {
            await aaClient.switchChain({ id: appChain.id });
        }
        try {
            if (isLiveBet) {
                const fixedMinOdds = calcMindOdds({ odds: totalOdds, slippage });
                const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                const { conditionId, outcomeId } = selections[0];
                if (isAAWallet && isApproveRequired) {
                    const hash = await aaClient.sendTransaction({
                        to: betToken.address,
                        data: encodeFunctionData({
                            abi: erc20Abi,
                            functionName: 'approve',
                            args: [
                                approveAddress,
                                maxUint256,
                            ],
                        }),
                    });
                    await publicClient?.waitForTransactionReceipt({
                        hash,
                        confirmations: 1,
                    });
                }
                bets.push({
                    rawAmount,
                    selections,
                });
                const liveBet = {
                    attention: liveEIP712Attention || 'By signing this transaction, I agree to place a bet for a live event on \'Azuro SDK Example',
                    affiliate,
                    core: contracts.liveCore.address,
                    amount: String(rawAmount),
                    chainId: appChain.id,
                    conditionId: conditionId,
                    outcomeId: +outcomeId,
                    minOdds: String(rawMinOdds),
                    nonce: String(Date.now()),
                    expiresAt: Math.floor(Date.now() / 1000) + 2000,
                    relayerFeeAmount: String(rawRelayerFeeAmount),
                };
                const typedData = getLiveBetTypedData({
                    account: account.address,
                    chainId: appChain.id,
                    bet: liveBet,
                });
                const signature = isAAWallet
                    ? await aaClient.signTypedData({ ...typedData, account: aaClient.account })
                    : await walletClient.data.signTypedData(typedData);
                const createdOrder = await createLiveBet({
                    account: account.address,
                    chainId: appChain.id,
                    bet: liveBet,
                    signature,
                });
                const { id: orderId, state: newOrderState, errorMessage, } = createdOrder;
                if (newOrderState === LiveBetState.Created) {
                    txHash = await new Promise((res, rej) => {
                        const interval = setInterval(async () => {
                            const order = await getLiveBet({
                                chainId: appChain.id,
                                orderId,
                            });
                            const { state, txHash } = order;
                            if (state === LiveBetState.Rejected) {
                                clearInterval(interval);
                                rej();
                            }
                            if (txHash) {
                                clearInterval(interval);
                                res(txHash);
                            }
                        }, 1000);
                    });
                    updateLiveOrAABetTx({
                        data: txHash,
                        isPending: false,
                    });
                }
                else {
                    throw Error(errorMessage);
                }
            }
            else if (isFreeBet) {
                const { coreAddress, conditionId, outcomeId } = selections[0];
                const { id, expiresAt, contractAddress, rawMinOdds, rawAmount, signature, chainId } = freeBet;
                const fixedSelectionMinOdds = calcMindOdds({ odds: odds[`${conditionId}-${outcomeId}`], slippage });
                const rawSelectionMinOdds = parseUnits(fixedSelectionMinOdds, ODDS_DECIMALS);
                const rawFreeBetMinOdds = rawMinOdds > rawSelectionMinOdds ? rawMinOdds : rawSelectionMinOdds;
                bets.push({
                    rawAmount,
                    selections,
                    freebetContractAddress: contractAddress,
                    freebetId: String(id),
                });
                const data = encodeFunctionData({
                    abi: freeBetAbi,
                    functionName: 'bet',
                    args: [
                        {
                            chainId: BigInt(chainId),
                            expiresAt: BigInt(Math.floor(expiresAt / 1000)),
                            amount: rawAmount,
                            freeBetId: BigInt(id),
                            minOdds: rawMinOdds,
                            owner: account.address,
                        },
                        signature,
                        coreAddress,
                        BigInt(conditionId),
                        BigInt(outcomeId),
                        rawDeadline,
                        rawFreeBetMinOdds,
                    ],
                });
                txHash = isAAWallet ? await aaClient.sendTransaction({ to: contractAddress, data, chain: appChain }) : await betTx.sendTransactionAsync({
                    to: contractAddress,
                    data,
                    ...(betGas || {}),
                });
            }
            else {
                let betData;
                if (isBatch) {
                    betData = selections.map(selection => {
                        const { conditionId, outcomeId } = selection;
                        const fixedAmount = parseFloat(_betAmount[`${conditionId}-${outcomeId}`]).toFixed(betToken.decimals);
                        const rawAmount = parseUnits(fixedAmount, betToken.decimals);
                        const fixedMinOdds = calcMindOdds({ odds: odds[`${conditionId}-${outcomeId}`], slippage });
                        const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                        const data = getPrematchBetDataBytes([selection]);
                        bets.push({
                            rawAmount,
                            selections: [selection],
                        });
                        return {
                            core: contracts.prematchCore.address,
                            amount: rawAmount,
                            expiresAt: rawDeadline,
                            extraData: {
                                affiliate,
                                minOdds: rawMinOdds,
                                data,
                            },
                        };
                    });
                }
                else {
                    const fixedMinOdds = calcMindOdds({ odds: totalOdds, slippage });
                    const rawMinOdds = parseUnits(fixedMinOdds, ODDS_DECIMALS);
                    const coreAddress = selections.length > 1 ? contracts.prematchComboCore.address : contracts.prematchCore.address;
                    const data = getPrematchBetDataBytes(selections);
                    bets.push({
                        rawAmount,
                        selections,
                    });
                    betData = [
                        {
                            core: coreAddress,
                            amount: rawAmount,
                            expiresAt: rawDeadline,
                            extraData: {
                                affiliate,
                                minOdds: rawMinOdds,
                                data,
                            },
                        },
                    ];
                }
                const betTxDTO = {
                    to: contracts.proxyFront.address,
                    data: encodeFunctionData({
                        abi: contracts.proxyFront.abi,
                        functionName: 'bet',
                        args: [
                            contracts.lp.address,
                            betData,
                        ],
                    }),
                    ...(betGas || {}),
                };
                if (isAAWallet) {
                    const calls = isApproveRequired ? [
                        {
                            to: betToken.address,
                            data: encodeFunctionData({
                                abi: erc20Abi,
                                functionName: 'approve',
                                args: [
                                    approveAddress,
                                    maxUint256,
                                ],
                            }),
                        },
                        betTxDTO,
                    ] : [
                        betTxDTO,
                    ];
                    txHash = await aaClient.sendTransaction({
                        calls,
                    });
                    updateLiveOrAABetTx({
                        data: txHash,
                        isPending: false,
                    });
                }
                else {
                    txHash = await betTx.sendTransactionAsync(betTxDTO);
                }
            }
            const receipt = await publicClient?.waitForTransactionReceipt({
                hash: txHash,
            });
            refetchBetTokenBalance();
            refetchNativeBalance();
            allowanceTx.refetch();
            if (isFreeBet) {
                const queryKey = ['freebets', api, account.address.toLowerCase(), affiliate.toLowerCase()];
                await queryClient.cancelQueries({ queryKey });
                queryClient.setQueryData(queryKey, (oldFreeBets) => {
                    const newFreeBets = [...oldFreeBets].filter(({ id, contractAddress }) => {
                        return contractAddress.toLowerCase() !== freeBet.contractAddress.toLowerCase() || id !== freeBet.id;
                    });
                    return newFreeBets;
                });
            }
            if (receipt) {
                bets.forEach((bet) => {
                    addBet({
                        receipt,
                        affiliate,
                        odds,
                        bet,
                    });
                });
            }
            if (onSuccess) {
                onSuccess(receipt);
            }
        }
        catch (err) {
            if (isLiveBet) {
                updateLiveOrAABetTx({
                    isPending: false,
                });
            }
            if (onError) {
                onError(err);
            }
        }
    };
    const submit = () => {
        if (isApproveRequired && !isAAWallet) {
            return approve();
        }
        return placeBet();
    };
    return {
        submit,
        approveTx: {
            isPending: approveTx.isPending,
            isProcessing: approveReceipt.isLoading,
        },
        betTx: {
            data: betTx.data || liveOrAABetTx.data,
            isPending: betTx.isPending || liveOrAABetTx.isPending,
            isProcessing: betReceipt.isLoading,
        },
        relayerFeeAmount,
        isAllowanceLoading: allowanceTx.isLoading,
        isApproveRequired: isAAWallet ? false : isApproveRequired,
        isRelayerFeeLoading: isRelayerFeeFetching,
    };
};const useSelection = ({ selection, initialOdds, initialStatus }) => {
    const { coreAddress, conditionId, outcomeId } = selection;
    const { appChain, contracts } = useChain();
    const { prematchClient } = useApolloClients();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const config = useConfig();
    const isLive = coreAddress.toLowerCase() === liveHostAddress.toLowerCase();
    const [odds, setOdds] = useState(initialOdds || 0);
    const [isOddsFetching, setOddsFetching] = useState(!initialOdds);
    const [status, setStatus] = useState(initialStatus || ConditionStatus.Created);
    const [isStatusFetching, setStatusFetching] = useState(!initialStatus);
    const isLocked = status !== ConditionStatus.Created;
    useEffect(() => {
        if (!isLive || !isSocketReady) {
            return;
        }
        subscribeToUpdates([conditionId]);
        return () => {
            unsubscribeToUpdates([conditionId]);
        };
    }, [isSocketReady]);
    useEffect(() => {
        const unsubscribe = oddsWatcher.subscribe(`${conditionId}`, `${outcomeId}`, async (oddsData) => {
            let odds = oddsData?.outcomes?.[String(outcomeId)]?.odds;
            if (!odds) {
                const rawOdds = await readContract(config, {
                    address: contracts.prematchCore.address,
                    abi: contracts.prematchCore.abi,
                    functionName: 'calcOdds',
                    chainId: appChain.id,
                    args: [
                        BigInt(conditionId),
                        BigInt(1),
                        BigInt(outcomeId),
                    ],
                });
                odds = formatUnits(rawOdds, ODDS_DECIMALS);
            }
            else {
                setOddsFetching(false);
            }
            setOdds(+odds);
        });
        return () => {
            unsubscribe();
        };
    }, [config]);
    useEffect(() => {
        const unsubscribe = conditionStatusWatcher.subscribe(`${conditionId}`, (newStatus) => {
            setStatusFetching(false);
            setStatus(newStatus);
        });
        return () => {
            unsubscribe();
        };
    }, []);
    useEffect(() => {
        if (isLive || (initialOdds && initialStatus)) {
            return;
        }
        (async () => {
            const conditionEntityId = `${contracts.prematchCore.address.toLowerCase()}_${conditionId}`;
            const key = `${conditionId}-${outcomeId}`;
            const data = await batchFetchOutcomes([conditionEntityId], prematchClient);
            if (!initialOdds) {
                setOdds(data?.[key]?.odds || 0);
                setOddsFetching(false);
            }
            if (!initialStatus) {
                setStatus(data?.[key]?.status || ConditionStatus.Created);
                setStatusFetching(false);
            }
        })();
    }, [prematchClient]);
    return {
        odds,
        isLocked,
        isOddsFetching,
        isStatusFetching,
    };
};const useGameStatus = ({ graphStatus, startsAt, isGameExistInLive }) => {
    const startDate = +startsAt * 1000;
    const [isGameStarted, setGameStarted] = useState(Date.now() > startDate);
    const gameStatus = useMemo(() => {
        return getGameStatus({
            graphStatus,
            startsAt,
            isGameInLive: isGameExistInLive,
        });
    }, [graphStatus, isGameStarted, isGameExistInLive]);
    useEffect(() => {
        if (isGameStarted) {
            return;
        }
        const timer = setTimeout(() => {
            setGameStarted(true);
        }, startDate - Date.now());
        return () => {
            clearTimeout(timer);
        };
    }, [startDate]);
    return {
        status: gameStatus,
        isGameStarted,
    };
};const findActiveCondition = ({ statuses, marketsByKey, sortedMarketKeys, activeMarketKey }) => {
    // try to find condition with Created status in active market
    let nextConditionIndex = marketsByKey[activeMarketKey].outcomeRows.findIndex((outcomes) => {
        return outcomes.some(({ conditionId }) => statuses[conditionId] === ConditionStatus.Created);
    });
    if (nextConditionIndex !== -1) {
        return {
            nextMarketKey: activeMarketKey,
            nextConditionIndex,
        };
    }
    else {
        // try to find next market and condition with Created status
        nextConditionIndex = 0;
        const nextMarketKey = sortedMarketKeys.find(marketKey => {
            return marketsByKey[marketKey].outcomeRows.find((outcomes, index) => {
                const isMatch = statuses[outcomes[0].conditionId] === ConditionStatus.Created;
                if (isMatch) {
                    nextConditionIndex = index;
                }
                return isMatch;
            });
        });
        if (nextMarketKey) {
            return {
                nextMarketKey,
                nextConditionIndex,
            };
        }
        return {};
    }
};const getConditions = async (conditionIds, api) => {
    const response = await fetch(`${api}/conditions`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ids: [...conditionIds],
        }),
    });
    const data = await response.json();
    if (response.status === 404 || !response.ok) {
        return {};
    }
    return data?.reduce((acc, condition) => {
        const { id: conditionId } = condition;
        acc[conditionId] = condition;
        return acc;
    }, {});
};
const batchFetchLiveConditions = createBatch(getConditions);const useActiveMarket = ({ markets }) => {
    const { api } = useChain();
    const isMounted = useIsMounted();
    const { isSocketReady, subscribeToUpdates, unsubscribeToUpdates } = useSocket();
    const { sortedMarketKeys, marketsByKey } = useMemo(() => {
        const defaultValue = {
            sortedMarketKeys: [],
            marketsByKey: {},
        };
        if (!markets?.length) {
            return defaultValue;
        }
        return markets.reduce((acc, market) => {
            const { marketKey } = market;
            acc.sortedMarketKeys.push(marketKey);
            acc.marketsByKey[marketKey] = market;
            return acc;
        }, defaultValue);
    }, [markets]);
    const [activeMarketKey, setActiveMarketKey] = useState(sortedMarketKeys[0]);
    const [activeConditionIndex, setActiveConditionIndex] = useState(0);
    const otherMarkets = useMemo(() => {
        return sortedMarketKeys.filter(key => key !== activeMarketKey);
    }, [activeMarketKey, sortedMarketKeys]);
    const isLive = (markets?.[0]?.outcomeRows?.[0]?.[0]?.coreAddress?.toLocaleLowerCase() === liveHostAddress.toLocaleLowerCase());
    const selections = useMemo(() => {
        return markets.reduce((acc, market) => {
            const { outcomeRows } = market;
            outcomeRows.forEach(outcomes => {
                outcomes.forEach((outcome) => {
                    acc.push(outcome);
                });
            });
            return acc;
        }, []);
    }, [markets]);
    // prematch part start
    const { statuses: prematchStatuses, loading: isPrematchStatusesFetching } = useStatuses({
        selections: isLive ? [] : selections,
    });
    useEffect(() => {
        if (isLive || !markets?.length) {
            return;
        }
        const activeConditionId = marketsByKey[activeMarketKey].outcomeRows[activeConditionIndex][0].conditionId;
        const activeStatus = (prematchStatuses[activeConditionId] || ConditionStatus.Created);
        if (activeStatus === ConditionStatus.Created) {
            return;
        }
        const { nextMarketKey, nextConditionIndex } = findActiveCondition({
            statuses: prematchStatuses,
            marketsByKey,
            sortedMarketKeys,
            activeMarketKey,
        });
        if (nextMarketKey) {
            setActiveMarketKey(nextMarketKey);
        }
        if (nextConditionIndex) {
            setActiveConditionIndex(nextConditionIndex);
        }
    }, [prematchStatuses]);
    // prematch part end
    // live part start
    const [liveConditionStatus, setLiveConditionStatus] = useState(ConditionStatus.Created);
    useEffect(() => {
        if (!isLive || !markets.length) {
            return;
        }
        const activeConditionId = marketsByKey[activeMarketKey].outcomeRows[activeConditionIndex][0].conditionId;
        const unsubscribe = conditionStatusWatcher.subscribe(activeConditionId, (newStatus) => {
            setLiveConditionStatus(newStatus);
        });
        return () => {
            unsubscribe();
        };
    }, [activeMarketKey, activeConditionIndex]);
    useEffect(() => {
        if (!isLive || !markets?.length || !isSocketReady) {
            return;
        }
        const activeConditionId = marketsByKey[activeMarketKey].outcomeRows[activeConditionIndex][0].conditionId;
        subscribeToUpdates([activeConditionId]);
        return () => {
            unsubscribeToUpdates([activeConditionId]);
        };
    }, [activeMarketKey, activeConditionIndex, isSocketReady]);
    useEffect(() => {
        if (!isLive || !markets?.length || liveConditionStatus === ConditionStatus.Created) {
            return;
        }
        let timeout;
        const getNextMarket = async () => {
            try {
                const conditionIds = [
                    ...new Set(selections.map(({ conditionId }) => conditionId)),
                ];
                const data = await batchFetchLiveConditions(conditionIds, api);
                if (!isMounted()) {
                    return;
                }
                const statusByConditionId = conditionIds.reduce((acc, conditionId) => {
                    const { state } = data[conditionId] || { state: ConditionStatus.Paused };
                    acc[conditionId] = state;
                    return acc;
                }, {});
                const { nextMarketKey, nextConditionIndex } = findActiveCondition({
                    statuses: statusByConditionId,
                    marketsByKey,
                    sortedMarketKeys,
                    activeMarketKey,
                });
                if (nextMarketKey) {
                    setActiveMarketKey(nextMarketKey);
                    if (nextConditionIndex) {
                        setActiveConditionIndex(nextConditionIndex);
                    }
                    setLiveConditionStatus(ConditionStatus.Created);
                }
                // refetch in timeout
                else {
                    const isContainsPausedState = Object.values(statusByConditionId).some(status => status === ConditionStatus.Paused);
                    // if we have condition in paused state
                    // then refetch statuses in 10s
                    if (isContainsPausedState) {
                        timeout = setTimeout(() => {
                            if (isMounted()) {
                                getNextMarket();
                            }
                        }, 10_000);
                    }
                }
            }
            catch { }
        };
        getNextMarket();
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [activeMarketKey, activeConditionIndex, liveConditionStatus]);
    // live part end
    return {
        marketsByKey,
        activeMarketKey,
        activeConditionIndex,
        otherMarkets,
        sortedMarketKeys,
        loading: isPrematchStatusesFetching,
    };
};const useWaveLevels = ({ waveId } = { waveId: 'active' }) => {
    const { appChain, api } = useChain();
    const queryFn = () => (getWaveLevels({
        chainId: appChain.id,
        waveId,
    }));
    return useQuery({
        queryKey: ['wave/levels', waveId, api],
        queryFn,
        refetchOnWindowFocus: false,
    });
};const useWaveStats = ({ account, waveId = 'active' }) => {
    const { appChain, api } = useChain();
    const queryFn = async () => {
        const data = await getWaveStats({
            account,
            waveId,
            chainId: appChain.id,
        });
        if (!data) {
            return data;
        }
        const { address, levelActivated, ...rest } = data;
        return {
            ...rest,
            isActivated: levelActivated,
        };
    };
    return useQuery({
        queryKey: ['wave/stats', waveId, api, account?.toLowerCase()],
        queryFn,
        refetchOnWindowFocus: false,
        enabled: Boolean(account),
    });
};const useWavePeriods = ({ waveId } = { waveId: 'active' }) => {
    const { appChain, api } = useChain();
    const queryFn = async () => {
        const data = await getWavePeriods({
            waveId,
            chainId: appChain.id,
        });
        if (!data) {
            return data;
        }
        return [...data].reverse().map(({ id, startsAt, endsAt, totalPoints }, index) => {
            const fromTimestamp = new Date(startsAt).getTime();
            const toTimestamp = new Date(endsAt).getTime() - 1000;
            return {
                id,
                startsAt: Math.floor(fromTimestamp / 1000),
                endsAt: Math.floor(toTimestamp / 1000),
                totalPoints,
                isBonusPreCalc: !index,
            };
        });
    };
    return useQuery({
        queryKey: ['wave/periods', waveId, api],
        queryFn,
        refetchOnWindowFocus: false,
    });
};const useWaveLeaderBoard = ({ waveId = 'active', account, startsAt, enabled }) => {
    const { appChain, api } = useChain();
    const queryFn = () => (getWaveLeaderBoard({
        waveId,
        account,
        startsAt,
        chainId: appChain.id,
    }));
    return useQuery({
        queryKey: ['wave/leaderboard', waveId, api, account?.toLowerCase(), startsAt],
        queryFn,
        refetchOnWindowFocus: false,
        enabled,
    });
};const useWaveActivation = ({ account, waveId = 'active' }) => {
    const queryClient = useQueryClient();
    const { appChain, api } = useChain();
    const mutationFn = () => (activateWave({
        account,
        waveId,
        chainId: appChain.id,
    }));
    const { mutate, mutateAsync, isPending } = useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['wave/stats', waveId, api, account?.toLowerCase()] });
            queryClient.invalidateQueries({ queryKey: ['wave/leaderboard', waveId, api, account?.toLowerCase()] });
        },
    });
    return {
        activate: mutate,
        activateAsync: mutateAsync,
        isPending,
    };
};const useDeBridgeSupportedChains = ({ enabled } = { enabled: true }) => {
    const queryFn = async () => {
        const chains = await getDeBridgeSupportedChains();
        if (!chains) {
            return chains;
        }
        const chainIds = chains.map(({ originalChainId }) => originalChainId);
        return {
            chains,
            chainIds,
        };
    };
    const { isFetching, data, refetch } = useQuery({
        queryKey: ['/debridge-supported-chains'],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
    });
    return {
        supportedChains: data?.chains,
        supportedChainIds: data?.chainIds,
        refetch,
        loading: isFetching,
    };
};const useDeBridgeSupportedTokens = ({ chainId, enabled = true }) => {
    const queryFn = async () => {
        const tokens = await getDeBridgeSupportedTokens(chainId);
        if (!tokens) {
            return tokens;
        }
        const supportedTokens = Object.values(tokens);
        return {
            supportedTokens,
            tokenAddresses: supportedTokens.map(({ address }) => address),
        };
    };
    const { isFetching, data, refetch } = useQuery({
        queryKey: ['/debridge-supported-tokens', chainId],
        queryFn,
        enabled,
        refetchOnWindowFocus: false,
    });
    return {
        supportedTokens: data?.supportedTokens,
        supportedTokenAddresses: data?.tokenAddresses,
        refetch,
        loading: isFetching,
    };
};const useDeBridgeBet = (props) => {
    const { fromChainId, fromTokenAddress, betAmount, slippage, deadline, referralCode, affiliate, selections, odds, totalOdds, onSuccess, onError, } = props;
    const { prematchClient } = useApolloClients();
    const { addBet } = useBetsCache();
    const publicClient = usePublicClient();
    const config = useConfig();
    const account = useExtendedAccount();
    const { appChain, betToken } = useChain();
    const [isBetPending, setBetPending] = useState(false);
    const [isBetProcessing, setBetProcessing] = useState(false);
    const isLiveBet = selections.some(({ coreAddress }) => coreAddress === liveHostAddress);
    useEffect(() => {
        if (account.isAAWallet) {
            console.warn('Azuro SDK: deBridge must not be used with AA wallets.');
        }
    }, [account.isAAWallet]);
    const { supportedChainIds, loading: isDeBridgeSupportedChainsFetching, } = useDeBridgeSupportedChains({
        enabled: !isLiveBet,
    });
    const { supportedTokenAddresses, loading: isDeBridgeSupportedTokensFetching, } = useDeBridgeSupportedTokens({
        chainId: fromChainId,
        enabled: !isLiveBet && !isDeBridgeSupportedChainsFetching && (supportedChainIds || []).includes(fromChainId),
    });
    const queryFn = () => (createDeBridgeBet({
        account: account.address,
        betAmount,
        dstChainId: appChain.id,
        srcChainId: fromChainId,
        srcChainTokenIn: fromTokenAddress,
        selections,
        totalOdds,
        slippage,
        deadline,
        affiliate,
        referralCode,
    }));
    const selectionsKey = selections.map(({ conditionId }) => conditionId).join('-');
    const { isFetching: isCreateTxFetching, data } = useQuery({
        queryKey: ['/debridge-create-tx', fromChainId, fromTokenAddress, account?.address, betAmount, selectionsKey, totalOdds, slippage],
        queryFn,
        enabled: (!isLiveBet
            && !isBetPending
            && !isBetProcessing
            && Boolean(fromChainId)
            && Boolean(fromTokenAddress)
            && Boolean(account)
            && Boolean(+betAmount)
            && Boolean(selections.length)
            && Boolean(totalOdds) && totalOdds !== 1
            && !isDeBridgeSupportedChainsFetching
            && !isDeBridgeSupportedTokensFetching
            && (supportedChainIds || []).includes(appChain.id)
            && (supportedChainIds || []).includes(fromChainId)
            && (supportedTokenAddresses || []).includes(fromTokenAddress)),
        refetchOnWindowFocus: false,
        refetchInterval: 20000,
    });
    const { orderId, estimation, tx: betTxData, fixFee } = data || {};
    const isTxReady = Boolean(betTxData);
    const isNative = estimation?.srcChainTokenIn?.address === zeroAddress;
    const allowanceTx = useReadContract({
        chainId: fromChainId,
        address: estimation?.srcChainTokenIn.address,
        abi: erc20Abi,
        functionName: 'allowance',
        args: [
            account.address,
            betTxData?.to,
        ],
        query: {
            enabled: !isNative && Boolean(account.address) && isTxReady,
            refetchOnWindowFocus: false,
        },
    });
    const isApproveRequired = Boolean(allowanceTx.data !== undefined
        && allowanceTx.data < (BigInt(estimation?.srcChainTokenIn?.amount || 0) * 4n / 3n));
    const approveTx = useWriteContract();
    const betTx = useSendTransaction();
    const approveReceipt = useWaitForTransactionReceipt({
        hash: approveTx.data,
    });
    const approve = async () => {
        try {
            const hash = await approveTx.writeContractAsync({
                address: estimation?.srcChainTokenIn.address,
                abi: erc20Abi,
                chainId: fromChainId,
                functionName: 'approve',
                args: [
                    betTxData?.to,
                    maxUint256,
                ],
            });
            await publicClient.waitForTransactionReceipt({
                hash,
            });
            allowanceTx.refetch();
        }
        catch (err) {
            onError?.(err);
        }
    };
    const placeBet = async () => {
        try {
            setBetPending(true);
            const hash = await betTx.sendTransactionAsync(betTxData);
            setBetPending(false);
            setBetProcessing(true);
            if (publicClient?.chain?.id === fromChainId) {
                await publicClient.waitForTransactionReceipt({
                    hash,
                });
            }
            const txHash = await new Promise((res, rej) => {
                const interval = setInterval(async () => {
                    try {
                        const order = await getDeBridgeOrder(orderId);
                        const { state: orderStatus, externalCallState: betPlacingStatus, fulfilledDstEventMetadata, } = order;
                        const isBetPlaced = betPlacingStatus === DeBridgeExternalCallStatus.Completed;
                        const isOrderFulfilled = isBetPlaced || orderStatus === DeBridgeOrderStatus.Fulfilled || orderStatus === DeBridgeOrderStatus.ClaimedUnlock;
                        if (isOrderFulfilled) {
                            clearInterval(interval);
                            res(fulfilledDstEventMetadata?.transactionHash?.stringValue);
                        }
                        let error = '';
                        if (betPlacingStatus === DeBridgeExternalCallStatus.Cancelled) {
                            error = DeBridgeExternalCallStatus.Cancelled;
                        }
                        if (betPlacingStatus === DeBridgeExternalCallStatus.Failed) {
                            error = DeBridgeExternalCallStatus.Failed;
                        }
                        if (orderStatus === DeBridgeOrderStatus.SentOrderCancel) {
                            error = DeBridgeOrderStatus.SentOrderCancel;
                        }
                        if (orderStatus === DeBridgeOrderStatus.OrderCancelled) {
                            error = DeBridgeOrderStatus.OrderCancelled;
                        }
                        if (error) {
                            clearInterval(interval);
                            rej(error);
                        }
                    }
                    catch { }
                }, 5000);
            });
            let receipt;
            if (txHash) {
                receipt = await getTransactionReceipt(config, {
                    hash: txHash,
                    chainId: appChain.id,
                });
                if (receipt) {
                    const fixedAmount = parseFloat(betAmount).toFixed(betToken.decimals);
                    const rawAmount = parseUnits(fixedAmount, betToken.decimals);
                    addBet({
                        receipt,
                        affiliate,
                        odds,
                        bet: {
                            rawAmount,
                            selections,
                        },
                    });
                }
            }
            else {
                prematchClient.refetchQueries({
                    include: ['Bets'],
                });
            }
            setBetProcessing(false);
            onSuccess?.(receipt);
        }
        catch (err) {
            setBetPending(false);
            setBetProcessing(false);
            onError?.(err);
        }
    };
    const submit = () => {
        if (account.isAAWallet) {
            console.error('Azuro SDK: deBridge must not be used with AA wallets.');
            return;
        }
        if (isApproveRequired) {
            return approve();
        }
        return placeBet();
    };
    return {
        orderId,
        submit,
        estimation,
        fixFee,
        supportedChainIds,
        approveTx: {
            isPending: approveTx.isPending,
            isProcessing: approveReceipt.isLoading,
        },
        betTx: {
            isPending: isBetPending,
            isProcessing: isBetProcessing,
        },
        isAllowanceLoading: allowanceTx.isLoading,
        isApproveRequired,
        isTxReady,
        loading: isCreateTxFetching || isDeBridgeSupportedChainsFetching,
    };
};export{ApolloProvider,AzuroSDKProvider,BaseBetslipContext,BetType,BetslipDisableReason,BetslipProvider,ChainProvider,DetailedBetslipContext,LiveContext,LiveProvider,SocketProvider,SportHub,Watchers,cookieKeys,getApolloClients,localStorageKeys,useActiveConditions,useActiveMarket,useActiveMarkets,useApolloClients,useBaseBetslip,useBetTokenBalance,useBetsSummary,useBetsSummaryBySelection,useChain,useConditions,useDeBridgeBet,useDeBridgeSupportedChains,useDeBridgeSupportedTokens,useDetailedBetslip,useFreeBets,useGame,useGameStatus,useGames,useLive,useLiveBetFee,useLiveBets,useNativeBalance,useNavigation,useOdds,usePrematchBets,usePrepareBet,useRedeemBet,useResolvedMarkets,useSelection,useSports,useSportsNavigation,useStatuses,useWatchers,useWaveActivation,useWaveLeaderBoard,useWaveLevels,useWavePeriods,useWaveStats};